//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), s = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, c = (n, r, o) => (o = n == null ? {} : e(i(n)), s(r || !n || !n.__esModule || !a.call(n, "default") ? t(o, "default", {
	value: n,
	enumerable: !0
}) : o, n));
//#endregion
//#region src/api/buildNetworkTracerApi.ts
function l(e, t, n) {
	return {
		...n,
		start: e.start,
		stop: e.stop,
		forceStop: e.forceStop,
		isEnabled: t.isEnabled,
		getState: t.getState,
		getPendingRequestCount: t.getPendingRequestCount
	};
}
//#endregion
//#region src/api/buildNetworkTracerConfigApi.ts
function u(e) {
	return {
		getEnabledOnLoad: () => e.getConfig().enabledOnLoad,
		setEnabledOnLoad: e.setEnabledOnLoad,
		getCaptureRequestHeaders: () => e.getConfig().captureRequestHeaders,
		setCaptureRequestHeaders: e.setCaptureRequestHeaders,
		getCaptureRequestBody: () => e.getConfig().captureRequestBody,
		setCaptureRequestBody: e.setCaptureRequestBody,
		getCaptureResponseHeaders: () => e.getConfig().captureResponseHeaders,
		setCaptureResponseHeaders: e.setCaptureResponseHeaders,
		getCaptureResponseBody: () => e.getConfig().captureResponseBody,
		setCaptureResponseBody: e.setCaptureResponseBody,
		getBodyCaptureLimit: () => e.getConfig().bodyCaptureLimit,
		setBodyCaptureLimit: e.setBodyCaptureLimit,
		getIncludePatterns: () => e.getConfig().includePatterns,
		setIncludePatterns: e.setIncludePatterns,
		getExcludePatterns: () => e.getConfig().excludePatterns,
		setExcludePatterns: e.setExcludePatterns,
		getRedactionPatterns: () => e.getConfig().redactionPatterns,
		setRedactionPatterns: e.setRedactionPatterns,
		getWaitForPendingRequestsOnStop: () => e.getConfig().waitForPendingRequestsOnStop,
		setWaitForPendingRequestsOnStop: e.setWaitForPendingRequestsOnStop,
		getAutoStopAfterRequests: () => e.getConfig().autoStopAfterRequests,
		setAutoStopAfterRequests: e.setAutoStopAfterRequests,
		getConfig: e.getConfig,
		resetConfig: e.resetConfig
	};
}
//#endregion
//#region src/events/createAutomaticTracingStoppedEvent.ts
function d(e) {
	return {
		kind: "automatic-tracing-stopped",
		tokens: [{
			role: "runtime-control",
			text: `Network tracing stopped automatically (limit: ${e} requests)`
		}]
	};
}
//#endregion
//#region src/automatic-stop/beginAutomaticNetworkTracingDrain.ts
function f(e, t, n) {
	n.setFinalEvent(d(e)), t.enterStopping();
}
//#endregion
//#region src/events/createTracingStoppedEvent.ts
function p() {
	return {
		kind: "tracing-stopped",
		tokens: [{
			role: "runtime-control",
			text: "Network tracing stopped"
		}]
	};
}
//#endregion
//#region src/state/shouldFinalizeDrain.ts
function m(e, t) {
	return e === "stopping" && t === 0;
}
//#endregion
//#region src/api/finalizeNetworkTracingDrain.ts
function h(e, t) {
	m(e.getState(), e.getPendingRequestCount()) && (e.enterStopped(), t());
}
//#endregion
//#region src/state/settleNetworkTracingWork.ts
function g(e, t, n) {
	e.settlePendingWork();
	let r = t.getFinalEvent();
	if (r === void 0) return;
	let i = r;
	function a() {
		t.clearFinalEvent();
		try {
			n(i);
		} catch {}
	}
	h(e, a);
}
//#endregion
//#region src/state/getForceStopTransition.ts
function _(e) {
	return e === "stopped" ? e : "stopped";
}
//#endregion
//#region src/api/forceStopNetworkTracing.ts
function v(e, t) {
	let n = e.getState();
	_(n) !== n && (e.enterStopped(), t(p()));
}
//#endregion
//#region src/events/createTracingStartedEvent.ts
function y() {
	return {
		kind: "tracing-started",
		tokens: [{
			role: "runtime-control",
			text: "Network tracing started"
		}]
	};
}
//#endregion
//#region src/state/getStartTransition.ts
function b(e) {
	return e === "running" ? e : "running";
}
//#endregion
//#region src/api/startNetworkTracing.ts
function x(e, t, n) {
	let r = e.getState();
	b(r) !== r && (r === "stopped" && (t.resetRequestIds(), t.resetAdmittedRequestCount()), e.enterRunning(), n(y()));
}
//#endregion
//#region src/events/createTracingStoppingEvent.ts
function S(e) {
	return {
		kind: "tracing-stopping",
		tokens: [{
			role: "runtime-control",
			text: `Network tracing stopping (${e} requests pending)`
		}]
	};
}
//#endregion
//#region src/state/getManualStopTransition.ts
function ee(e, t) {
	return e === "running" ? t ? "stopping" : "stopped" : e;
}
//#endregion
//#region src/api/stopNetworkTracing.ts
function te(e, t, n) {
	let r = e.getState(), i = ee(r, t());
	if (i !== r) {
		if (i === "stopping") {
			e.enterStopping(), n(S(e.getPendingRequestCount()));
			return;
		}
		e.enterStopped(), n(p());
	}
}
//#endregion
//#region src/api/createNetworkTracingCommands.ts
function ne(e) {
	function t() {
		e.drainStore.clearFinalEvent(), x(e.stateStore, {
			...e.requestIds,
			...e.admittedRequests
		}, (t) => e.emit(t));
	}
	function n() {
		if (e.stateStore.getState() !== "running") return;
		let t = e.getWaitForPendingRequests();
		t ? e.drainStore.setFinalEvent(p()) : e.drainStore.clearFinalEvent(), te(e.stateStore, () => t, (t) => e.emit(t)), t && o();
	}
	function r() {
		e.stateStore.getState() !== "stopped" && (e.drainStore.clearFinalEvent(), v(e.stateStore, (t) => e.emit(t)));
	}
	function i(t) {
		f(t, e.stateStore, e.drainStore);
	}
	function a() {
		g(e.stateStore, e.drainStore, (t) => e.emit(t));
	}
	function o() {
		e.stateStore.getPendingRequestCount() === 0 && (e.stateStore.beginPendingWork(), a());
	}
	return {
		start: t,
		stop: n,
		forceStop: r,
		enterAutomaticStopping: i,
		settlePendingWork: a
	};
}
//#endregion
//#region src/configuration/validateAutoStopAfterRequests.ts
function re(e) {
	if (e !== void 0) {
		if (typeof e != "number" || !Number.isInteger(e) || e <= 0) throw Error("NetworkTracer: autoStopAfterRequests must be a positive integer or undefined");
		return e;
	}
}
//#endregion
//#region src/configuration/validateBodyCaptureLimit.ts
function ie(e) {
	if (typeof e != "number" || !Number.isInteger(e) || e <= 0) throw Error("NetworkTracer: bodyCaptureLimit must be a positive integer");
	return e;
}
//#endregion
//#region src/configuration/readPersistedNetworkTracerConfig.ts
function ae(e) {
	let t = e.getItem("__autotracer.network.config.v1");
	if (t !== null) try {
		let e = JSON.parse(t);
		if (typeof e != "object" || !e || !("version" in e) || e.version !== 1 || !("config" in e) || typeof e.config != "object" || e.config === null) return;
		let n = e.config, r = "enabledOnLoad" in n ? n.enabledOnLoad : void 0, i = "captureRequestHeaders" in n ? n.captureRequestHeaders : void 0, a = "captureRequestBody" in n ? n.captureRequestBody : void 0, o = "captureResponseHeaders" in n ? n.captureResponseHeaders : void 0, s = "captureResponseBody" in n ? n.captureResponseBody : void 0, c = "bodyCaptureLimit" in n ? n.bodyCaptureLimit : void 0, l = "redactionPatterns" in n ? n.redactionPatterns : void 0, u = "includePatterns" in n ? n.includePatterns : void 0, d = "excludePatterns" in n ? n.excludePatterns : void 0, f = "waitForPendingRequestsOnStop" in n ? n.waitForPendingRequestsOnStop : void 0, p = "autoStopAfterRequests" in n ? n.autoStopAfterRequests : void 0, m = [
			"enabledOnLoad",
			"captureRequestHeaders",
			"captureRequestBody",
			"captureResponseHeaders",
			"captureResponseBody",
			"bodyCaptureLimit",
			"redactionPatterns",
			"includePatterns",
			"excludePatterns",
			"waitForPendingRequestsOnStop",
			"autoStopAfterRequests"
		];
		if (Object.keys(n).some((e) => !m.includes(e)) || r !== void 0 && typeof r != "boolean" || i !== void 0 && typeof i != "boolean" || a !== void 0 && typeof a != "boolean" || o !== void 0 && typeof o != "boolean" || s !== void 0 && typeof s != "boolean" || l !== void 0 && (!Array.isArray(l) || !l.every((e) => typeof e == "string")) || u !== void 0 && (!Array.isArray(u) || !u.every((e) => typeof e == "string")) || d !== void 0 && (!Array.isArray(d) || !d.every((e) => typeof e == "string")) || f !== void 0 && typeof f != "boolean") return;
		let h = c === void 0 ? void 0 : ie(c), g = re(p);
		return {
			...r === void 0 ? {} : { enabledOnLoad: r },
			...i === void 0 ? {} : { captureRequestHeaders: i },
			...a === void 0 ? {} : { captureRequestBody: a },
			...o === void 0 ? {} : { captureResponseHeaders: o },
			...s === void 0 ? {} : { captureResponseBody: s },
			...h === void 0 ? {} : { bodyCaptureLimit: h },
			...l === void 0 ? {} : { redactionPatterns: [...l] },
			...u === void 0 ? {} : { includePatterns: [...u] },
			...d === void 0 ? {} : { excludePatterns: [...d] },
			...f === void 0 ? {} : { waitForPendingRequestsOnStop: f },
			...g === void 0 ? {} : { autoStopAfterRequests: g }
		};
	} catch {
		return;
	}
}
//#endregion
//#region src/configuration/defaultNetworkTracerConfig.ts
var oe = {
	enabledOnLoad: !1,
	captureRequestHeaders: !1,
	captureRequestBody: !1,
	captureResponseHeaders: !1,
	captureResponseBody: !1,
	bodyCaptureLimit: 65536,
	redactionPatterns: [
		"authorization",
		"cookie",
		"*token*",
		"*secret*",
		"*password*",
		"*signature*",
		"*x-api-key*"
	],
	includePatterns: [],
	excludePatterns: [],
	waitForPendingRequestsOnStop: !1,
	autoStopAfterRequests: void 0
};
//#endregion
//#region src/configuration/resolveNetworkTracerConfig.ts
function C(e, t) {
	let n = {
		...oe,
		...e,
		...t
	};
	return {
		...n,
		redactionPatterns: [...n.redactionPatterns],
		includePatterns: [...n.includePatterns],
		excludePatterns: [...n.excludePatterns]
	};
}
//#endregion
//#region src/configuration/writePersistedNetworkTracerConfig.ts
function w(e, t) {
	e.setItem("__autotracer.network.config.v1", JSON.stringify({
		version: 1,
		config: t
	}));
}
//#endregion
//#region src/configuration/createNetworkTracerConfigStore.ts
function se(e, t) {
	let n = ae(e) ?? {}, r = C(t, n);
	function i() {
		return {
			...r,
			redactionPatterns: [...r.redactionPatterns],
			includePatterns: [...r.includePatterns],
			excludePatterns: [...r.excludePatterns]
		};
	}
	function a(i) {
		let a = {
			...n,
			enabledOnLoad: i
		};
		w(e, a), n = a, r = C(t, n);
	}
	function o(i) {
		let a = {
			...n,
			captureRequestHeaders: i
		};
		w(e, a), n = a, r = C(t, n);
	}
	function s(i) {
		let a = {
			...n,
			captureRequestBody: i
		};
		w(e, a), n = a, r = C(t, n);
	}
	function c(i) {
		let a = {
			...n,
			captureResponseHeaders: i
		};
		w(e, a), n = a, r = C(t, n);
	}
	function l(i) {
		let a = {
			...n,
			captureResponseBody: i
		};
		w(e, a), n = a, r = C(t, n);
	}
	function u(i) {
		let a = ie(i), o = {
			...n,
			bodyCaptureLimit: a
		};
		w(e, o), n = o, r = C(t, n);
	}
	function d(i) {
		let a = {
			...n,
			waitForPendingRequestsOnStop: i
		};
		w(e, a), n = a, r = C(t, n);
	}
	function f(i) {
		let a = re(i), o = {
			...n,
			autoStopAfterRequests: a
		};
		w(e, o), n = o, r = C(t, n);
	}
	function p(i) {
		let a = [...i], o = {
			...n,
			redactionPatterns: a
		};
		w(e, o), n = o, r = C(t, n);
	}
	function m(i) {
		let a = i.find((e) => e.includes("{") !== e.includes("}"));
		if (a !== void 0) throw Error(`NetworkTracer: includePatterns contains an invalid glob: ${a}`);
		let o = [...i], s = {
			...n,
			includePatterns: o
		};
		w(e, s), n = s, r = C(t, n);
	}
	function h(i) {
		let a = i.find((e) => e.includes("{") !== e.includes("}"));
		if (a !== void 0) throw Error(`NetworkTracer: excludePatterns contains an invalid glob: ${a}`);
		let o = [...i], s = {
			...n,
			excludePatterns: o
		};
		w(e, s), n = s, r = C(t, n);
	}
	function g() {
		e.removeItem("__autotracer.network.config.v1"), n = { enabledOnLoad: !1 }, r = C(t, n);
	}
	return {
		getConfig: i,
		setEnabledOnLoad: a,
		setCaptureRequestHeaders: o,
		setCaptureRequestBody: s,
		setCaptureResponseHeaders: c,
		setCaptureResponseBody: l,
		setBodyCaptureLimit: u,
		setWaitForPendingRequestsOnStop: d,
		setAutoStopAfterRequests: f,
		setRedactionPatterns: p,
		setIncludePatterns: m,
		setExcludePatterns: h,
		resetConfig: g
	};
}
//#endregion
//#region src/identity/createIncludedRequestCountStore.ts
function ce() {
	let e = 0;
	function t() {
		return e;
	}
	function n(t) {
		e = t;
	}
	function r() {
		e = 0;
	}
	return {
		getAdmittedRequestCount: t,
		setAdmittedRequestCount: n,
		resetAdmittedRequestCount: r
	};
}
//#endregion
//#region src/identity/createRequestIdStore.ts
function le() {
	let e = 1;
	function t() {
		let t = e;
		return e += 1, t;
	}
	function n() {
		e = 1;
	}
	return {
		getNextRequestId: t,
		resetRequestIds: n
	};
}
//#endregion
//#region src/state/createNetworkTracerStateStore.ts
function ue(e) {
	let t = e ? "running" : "stopped", n = 0;
	function r() {
		return t;
	}
	function i() {
		return t === "running";
	}
	function a() {
		return n;
	}
	function o() {
		t = "running";
	}
	function s() {
		t = "stopping";
	}
	function c() {
		t = "stopped";
	}
	function l() {
		n += 1;
	}
	function u() {
		n = Math.max(0, n - 1);
	}
	return {
		getState: r,
		isEnabled: i,
		getPendingRequestCount: a,
		enterRunning: o,
		enterStopping: s,
		enterStopped: c,
		beginPendingWork: l,
		settlePendingWork: u
	};
}
//#endregion
//#region src/state/createNetworkTracingDrainStore.ts
function de() {
	let e;
	function t() {
		return e;
	}
	function n(t) {
		e = t;
	}
	function r() {
		e = void 0;
	}
	return {
		getFinalEvent: t,
		setFinalEvent: n,
		clearFinalEvent: r
	};
}
//#endregion
//#region src/automatic-stop/applyNetworkRequestAdmission.ts
function fe(e, t, n) {
	e.admitted && (t(e.admittedRequestCount), e.automaticStopTriggered && n(e.admittedRequestCount));
}
//#endregion
//#region src/capture/createRequestCaptureSnapshot.ts
function pe(e) {
	return {
		captureRequestHeaders: e.captureRequestHeaders,
		captureRequestBody: e.captureRequestBody,
		captureResponseHeaders: e.captureResponseHeaders,
		captureResponseBody: e.captureResponseBody,
		bodyCaptureLimit: e.bodyCaptureLimit,
		redactionPatterns: [...e.redactionPatterns]
	};
}
//#endregion
//#region src/events/createUnavailableDetailEvent.ts
function T(e, t) {
	return {
		kind: "unavailable-detail",
		tokens: [
			{
				role: "identity",
				text: `Network #${e}`
			},
			{
				role: "plain",
				text: "   "
			},
			{
				role: "label",
				text: t
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "unavailable",
				text: "UNAVAILABLE"
			}
		]
	};
}
//#endregion
//#region src/transport/getHeaderContentType.ts
function E(e) {
	return e.get("content-type");
}
//#endregion
//#region src/capture/cloneRequestForBodyCapture.ts
function me(e) {
	try {
		return e.clone();
	} catch {
		return;
	}
}
//#endregion
//#region src/body/createApplicationOwnedStreamBodySnapshot.ts
function he() {
	return {
		status: "not-captured",
		reason: "application-owned request stream"
	};
}
//#endregion
//#region src/body/createBinaryBodySnapshot.ts
function D(e, t) {
	return {
		status: "metadata-only",
		contentType: e,
		knownByteSize: t
	};
}
//#endregion
//#region src/body/createFormDataBodySnapshot.ts
function ge(e) {
	let t = [];
	for (let [n, r] of e.entries()) t.push(typeof r == "string" ? {
		kind: "text",
		name: n,
		value: r
	} : {
		kind: "file",
		name: n,
		fileName: r.name,
		contentType: r.type,
		byteSize: r.size
	});
	return t;
}
//#endregion
//#region src/body/truncateTextBodyAtLimit.ts
function _e(e, t) {
	let n = new TextEncoder(), r = n.encode(e).byteLength, i = 0, a = "";
	for (let r of e) {
		let e = n.encode(r).byteLength;
		if (i + e > t) break;
		a += r, i += e;
	}
	return {
		status: "captured",
		text: a,
		originalByteSize: r,
		capturedByteSize: i,
		truncated: i < r
	};
}
//#endregion
//#region src/body/createUrlEncodedBodySnapshot.ts
function ve(e, t) {
	return _e(e.toString(), t);
}
//#endregion
//#region src/body/getBodyByteSize.ts
function ye(e) {
	return e instanceof Blob ? e.size : e instanceof ArrayBuffer || ArrayBuffer.isView(e) ? e.byteLength : null;
}
//#endregion
//#region src/body/createNonTextBodySnapshot.ts
function be(e) {
	return e.body instanceof URLSearchParams ? ve(e.body, e.captureLimit) : e.body instanceof FormData ? ge(e.body) : e.body instanceof ReadableStream ? he() : D(e.contentType, ye(e.body));
}
//#endregion
//#region src/body/classifyBodyContentType.ts
function xe(e, t) {
	return e instanceof ReadableStream ? "stream" : e instanceof URLSearchParams ? "url-encoded" : e instanceof FormData ? "form-data" : typeof e == "string" ? t?.toLowerCase().includes("json") === !0 ? "json" : "text" : "binary";
}
//#endregion
//#region ../../node_modules/.pnpm/@isaacs+balanced-match@4.0.1/node_modules/@isaacs/balanced-match/dist/esm/index.js
var Se = (e, t, n) => {
	let r = e instanceof RegExp ? Ce(e, n) : e, i = t instanceof RegExp ? Ce(t, n) : t, a = r !== null && i != null && we(r, i, n);
	return a && {
		start: a[0],
		end: a[1],
		pre: n.slice(0, a[0]),
		body: n.slice(a[0] + r.length, a[1]),
		post: n.slice(a[1] + i.length)
	};
}, Ce = (e, t) => {
	let n = t.match(e);
	return n ? n[0] : null;
}, we = (e, t, n) => {
	let r, i, a, o, s, c = n.indexOf(e), l = n.indexOf(t, c + 1), u = c;
	if (c >= 0 && l > 0) {
		if (e === t) return [c, l];
		for (r = [], a = n.length; u >= 0 && !s;) {
			if (u === c) r.push(u), c = n.indexOf(e, u + 1);
			else if (r.length === 1) {
				let e = r.pop();
				e !== void 0 && (s = [e, l]);
			} else i = r.pop(), i !== void 0 && i < a && (a = i, o = l), l = n.indexOf(t, u + 1);
			u = c < l && c >= 0 ? c : l;
		}
		r.length && o !== void 0 && (s = [a, o]);
	}
	return s;
}, Te = "\0SLASH" + Math.random() + "\0", Ee = "\0OPEN" + Math.random() + "\0", O = "\0CLOSE" + Math.random() + "\0", k = "\0COMMA" + Math.random() + "\0", De = "\0PERIOD" + Math.random() + "\0", Oe = new RegExp(Te, "g"), ke = new RegExp(Ee, "g"), Ae = new RegExp(O, "g"), je = new RegExp(k, "g"), Me = new RegExp(De, "g"), Ne = /\\\\/g, Pe = /\\{/g, Fe = /\\}/g, Ie = /\\,/g, Le = /\\./g;
function A(e) {
	return isNaN(e) ? e.charCodeAt(0) : parseInt(e, 10);
}
function Re(e) {
	return e.replace(Ne, Te).replace(Pe, Ee).replace(Fe, O).replace(Ie, k).replace(Le, De);
}
function ze(e) {
	return e.replace(Oe, "\\").replace(ke, "{").replace(Ae, "}").replace(je, ",").replace(Me, ".");
}
function Be(e) {
	if (!e) return [""];
	let t = [], n = Se("{", "}", e);
	if (!n) return e.split(",");
	let { pre: r, body: i, post: a } = n, o = r.split(",");
	o[o.length - 1] += "{" + i + "}";
	let s = Be(a);
	return a.length && (o[o.length - 1] += s.shift(), o.push.apply(o, s)), t.push.apply(t, o), t;
}
function Ve(e) {
	return e ? (e.slice(0, 2) === "{}" && (e = "\\{\\}" + e.slice(2)), j(Re(e), !0).map(ze)) : [];
}
function He(e) {
	return "{" + e + "}";
}
function Ue(e) {
	return /^-?0\d/.test(e);
}
function We(e, t) {
	return e <= t;
}
function Ge(e, t) {
	return e >= t;
}
function j(e, t) {
	let n = [], r = Se("{", "}", e);
	if (!r) return [e];
	let i = r.pre, a = r.post.length ? j(r.post, !1) : [""];
	if (/\$$/.test(r.pre)) for (let e = 0; e < a.length; e++) {
		let t = i + "{" + r.body + "}" + a[e];
		n.push(t);
	}
	else {
		let o = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(r.body), s = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(r.body), c = o || s, l = r.body.indexOf(",") >= 0;
		if (!c && !l) return r.post.match(/,(?!,).*\}/) ? (e = r.pre + "{" + r.body + O + r.post, j(e)) : [e];
		let u;
		if (c) u = r.body.split(/\.\./);
		else if (u = Be(r.body), u.length === 1 && u[0] !== void 0 && (u = j(u[0], !1).map(He), u.length === 1)) return a.map((e) => r.pre + u[0] + e);
		let d;
		if (c && u[0] !== void 0 && u[1] !== void 0) {
			let e = A(u[0]), t = A(u[1]), n = Math.max(u[0].length, u[1].length), r = u.length === 3 && u[2] !== void 0 ? Math.abs(A(u[2])) : 1, i = We;
			t < e && (r *= -1, i = Ge);
			let a = u.some(Ue);
			d = [];
			for (let o = e; i(o, t); o += r) {
				let e;
				if (s) e = String.fromCharCode(o), e === "\\" && (e = "");
				else if (e = String(o), a) {
					let t = n - e.length;
					if (t > 0) {
						let n = Array(t + 1).join("0");
						e = o < 0 ? "-" + n + e.slice(1) : n + e;
					}
				}
				d.push(e);
			}
		} else {
			d = [];
			for (let e = 0; e < u.length; e++) d.push.apply(d, j(u[e], !1));
		}
		for (let e = 0; e < d.length; e++) for (let r = 0; r < a.length; r++) {
			let o = i + d[e] + a[r];
			(!t || c || o) && n.push(o);
		}
	}
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/minimatch@10.1.1/node_modules/minimatch/dist/esm/assert-valid-pattern.js
var Ke = 65536, M = (e) => {
	if (typeof e != "string") throw TypeError("invalid pattern");
	if (e.length > Ke) throw TypeError("pattern is too long");
}, qe = {
	"[:alnum:]": ["\\p{L}\\p{Nl}\\p{Nd}", !0],
	"[:alpha:]": ["\\p{L}\\p{Nl}", !0],
	"[:ascii:]": ["\\x00-\\x7f", !1],
	"[:blank:]": ["\\p{Zs}\\t", !0],
	"[:cntrl:]": ["\\p{Cc}", !0],
	"[:digit:]": ["\\p{Nd}", !0],
	"[:graph:]": [
		"\\p{Z}\\p{C}",
		!0,
		!0
	],
	"[:lower:]": ["\\p{Ll}", !0],
	"[:print:]": ["\\p{C}", !0],
	"[:punct:]": ["\\p{P}", !0],
	"[:space:]": ["\\p{Z}\\t\\r\\n\\v\\f", !0],
	"[:upper:]": ["\\p{Lu}", !0],
	"[:word:]": ["\\p{L}\\p{Nl}\\p{Nd}\\p{Pc}", !0],
	"[:xdigit:]": ["A-Fa-f0-9", !1]
}, N = (e) => e.replace(/[[\]\\-]/g, "\\$&"), Je = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), Ye = (e) => e.join(""), Xe = (e, t) => {
	let n = t;
	/* c8 ignore start */
	if (e.charAt(n) !== "[") throw Error("not in a brace expression");
	/* c8 ignore stop */
	let r = [], i = [], a = n + 1, o = !1, s = !1, c = !1, l = !1, u = n, d = "";
	WHILE: for (; a < e.length;) {
		let t = e.charAt(a);
		if ((t === "!" || t === "^") && a === n + 1) {
			l = !0, a++;
			continue;
		}
		if (t === "]" && o && !c) {
			u = a + 1;
			break;
		}
		if (o = !0, t === "\\" && !c) {
			c = !0, a++;
			continue;
		}
		if (t === "[" && !c) {
			for (let [t, [o, c, l]] of Object.entries(qe)) if (e.startsWith(t, a)) {
				if (d) return [
					"$.",
					!1,
					e.length - n,
					!0
				];
				a += t.length, l ? i.push(o) : r.push(o), s ||= c;
				continue WHILE;
			}
		}
		if (c = !1, d) {
			t > d ? r.push(N(d) + "-" + N(t)) : t === d && r.push(N(t)), d = "", a++;
			continue;
		}
		if (e.startsWith("-]", a + 1)) {
			r.push(N(t + "-")), a += 2;
			continue;
		}
		if (e.startsWith("-", a + 1)) {
			d = t, a += 2;
			continue;
		}
		r.push(N(t)), a++;
	}
	if (u < a) return [
		"",
		!1,
		0,
		!1
	];
	if (!r.length && !i.length) return [
		"$.",
		!1,
		e.length - n,
		!0
	];
	if (i.length === 0 && r.length === 1 && /^\\?.$/.test(r[0]) && !l) return [
		Je(r[0].length === 2 ? r[0].slice(-1) : r[0]),
		!1,
		u - n,
		!1
	];
	let f = "[" + (l ? "^" : "") + Ye(r) + "]", p = "[" + (l ? "" : "^") + Ye(i) + "]";
	return [
		r.length && i.length ? "(" + f + "|" + p + ")" : r.length ? f : p,
		s,
		u - n,
		!0
	];
}, P = (e, { windowsPathsNoEscape: t = !1, magicalBraces: n = !0 } = {}) => n ? t ? e.replace(/\[([^\/\\])\]/g, "$1") : e.replace(/((?!\\).|^)\[([^\/\\])\]/g, "$1$2").replace(/\\([^\/])/g, "$1") : t ? e.replace(/\[([^\/\\{}])\]/g, "$1") : e.replace(/((?!\\).|^)\[([^\/\\{}])\]/g, "$1$2").replace(/\\([^\/{}])/g, "$1"), Ze = /* @__PURE__ */ new Set([
	"!",
	"?",
	"+",
	"*",
	"@"
]), Qe = (e) => Ze.has(e), $e = "(?!(?:^|/)\\.\\.?(?:$|/))", F = "(?!\\.)", et = /* @__PURE__ */ new Set(["[", "."]), tt = /* @__PURE__ */ new Set(["..", "."]), nt = /* @__PURE__ */ new Set("().*{}+?[]^$\\!"), rt = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), it = "[^/]", at = "[^/]*?", ot = "[^/]+?", st = class e {
	type;
	#e;
	#t;
	#n = !1;
	#r = [];
	#i;
	#a;
	#o;
	#s = !1;
	#c;
	#l;
	#u = !1;
	constructor(e, t, n = {}) {
		this.type = e, e && (this.#t = !0), this.#i = t, this.#e = this.#i ? this.#i.#e : this, this.#c = this.#e === this ? n : this.#e.#c, this.#o = this.#e === this ? [] : this.#e.#o, e === "!" && !this.#e.#s && this.#o.push(this), this.#a = this.#i ? this.#i.#r.length : 0;
	}
	get hasMagic() {
		/* c8 ignore start */
		if (this.#t !== void 0) return this.#t;
		/* c8 ignore stop */
		for (let e of this.#r) if (typeof e != "string" && (e.type || e.hasMagic)) return this.#t = !0;
		return this.#t;
	}
	toString() {
		return this.#l === void 0 ? this.#l = this.type ? this.type + "(" + this.#r.map((e) => String(e)).join("|") + ")" : this.#r.map((e) => String(e)).join("") : this.#l;
	}
	#d() {
		/* c8 ignore start */
		if (this !== this.#e) throw Error("should only call on root");
		if (this.#s) return this;
		this.toString(), this.#s = !0;
		let e;
		for (; e = this.#o.pop();) {
			if (e.type !== "!") continue;
			let t = e, n = t.#i;
			for (; n;) {
				for (let r = t.#a + 1; !n.type && r < n.#r.length; r++) for (let t of e.#r) {
					/* c8 ignore start */
					if (typeof t == "string") throw Error("string part in extglob AST??");
					/* c8 ignore stop */
					t.copyIn(n.#r[r]);
				}
				t = n, n = t.#i;
			}
		}
		return this;
	}
	push(...t) {
		for (let n of t) if (n !== "") {
			/* c8 ignore start */
			if (typeof n != "string" && !(n instanceof e && n.#i === this)) throw Error("invalid part: " + n);
			/* c8 ignore stop */
			this.#r.push(n);
		}
	}
	toJSON() {
		let e = this.type === null ? this.#r.slice().map((e) => typeof e == "string" ? e : e.toJSON()) : [this.type, ...this.#r.map((e) => e.toJSON())];
		return this.isStart() && !this.type && e.unshift([]), this.isEnd() && (this === this.#e || this.#e.#s && this.#i?.type === "!") && e.push({}), e;
	}
	isStart() {
		if (this.#e === this) return !0;
		if (!this.#i?.isStart()) return !1;
		if (this.#a === 0) return !0;
		let t = this.#i;
		for (let n = 0; n < this.#a; n++) {
			let r = t.#r[n];
			if (!(r instanceof e && r.type === "!")) return !1;
		}
		return !0;
	}
	isEnd() {
		if (this.#e === this || this.#i?.type === "!") return !0;
		if (!this.#i?.isEnd()) return !1;
		if (!this.type) return this.#i?.isEnd();
		/* c8 ignore start */
		let e = this.#i ? this.#i.#r.length : 0;
		/* c8 ignore stop */
		return this.#a === e - 1;
	}
	copyIn(e) {
		typeof e == "string" ? this.push(e) : this.push(e.clone(this));
	}
	clone(t) {
		let n = new e(this.type, t);
		for (let e of this.#r) n.copyIn(e);
		return n;
	}
	static #f(t, n, r, i) {
		let a = !1, o = !1, s = -1, c = !1;
		if (n.type === null) {
			let l = r, u = "";
			for (; l < t.length;) {
				let r = t.charAt(l++);
				if (a || r === "\\") {
					a = !a, u += r;
					continue;
				}
				if (o) {
					l === s + 1 ? (r === "^" || r === "!") && (c = !0) : r === "]" && !(l === s + 2 && c) && (o = !1), u += r;
					continue;
				}
				if (r === "[") {
					o = !0, s = l, c = !1, u += r;
					continue;
				}
				if (!i.noext && Qe(r) && t.charAt(l) === "(") {
					n.push(u), u = "";
					let a = new e(r, n);
					l = e.#f(t, a, l, i), n.push(a);
					continue;
				}
				u += r;
			}
			return n.push(u), l;
		}
		let l = r + 1, u = new e(null, n), d = [], f = "";
		for (; l < t.length;) {
			let r = t.charAt(l++);
			if (a || r === "\\") {
				a = !a, f += r;
				continue;
			}
			if (o) {
				l === s + 1 ? (r === "^" || r === "!") && (c = !0) : r === "]" && !(l === s + 2 && c) && (o = !1), f += r;
				continue;
			}
			if (r === "[") {
				o = !0, s = l, c = !1, f += r;
				continue;
			}
			if (Qe(r) && t.charAt(l) === "(") {
				u.push(f), f = "";
				let n = new e(r, u);
				u.push(n), l = e.#f(t, n, l, i);
				continue;
			}
			if (r === "|") {
				u.push(f), f = "", d.push(u), u = new e(null, n);
				continue;
			}
			if (r === ")") return f === "" && n.#r.length === 0 && (n.#u = !0), u.push(f), f = "", n.push(...d, u), l;
			f += r;
		}
		return n.type = null, n.#t = void 0, n.#r = [t.substring(r - 1)], l;
	}
	static fromGlob(t, n = {}) {
		let r = new e(null, void 0, n);
		return e.#f(t, r, 0, n), r;
	}
	toMMPattern() {
		/* c8 ignore start */
		if (this !== this.#e) return this.#e.toMMPattern();
		/* c8 ignore stop */
		let e = this.toString(), [t, n, r, i] = this.toRegExpSource();
		if (!(r || this.#t || this.#c.nocase && !this.#c.nocaseMagicOnly && e.toUpperCase() !== e.toLowerCase())) return n;
		let a = (this.#c.nocase ? "i" : "") + (i ? "u" : "");
		return Object.assign(RegExp(`^${t}$`, a), {
			_src: t,
			_glob: e
		});
	}
	get options() {
		return this.#c;
	}
	toRegExpSource(t) {
		let n = t ?? !!this.#c.dot;
		if (this.#e === this && this.#d(), !this.type) {
			let r = this.isStart() && this.isEnd() && !this.#r.some((e) => typeof e != "string"), i = this.#r.map((n) => {
				let [i, a, o, s] = typeof n == "string" ? e.#m(n, this.#t, r) : n.toRegExpSource(t);
				return this.#t = this.#t || o, this.#n = this.#n || s, i;
			}).join(""), a = "";
			if (this.isStart() && typeof this.#r[0] == "string" && !(this.#r.length === 1 && tt.has(this.#r[0]))) {
				let e = et, r = n && e.has(i.charAt(0)) || i.startsWith("\\.") && e.has(i.charAt(2)) || i.startsWith("\\.\\.") && e.has(i.charAt(4)), o = !n && !t && e.has(i.charAt(0));
				a = r ? $e : o ? F : "";
			}
			let o = "";
			return this.isEnd() && this.#e.#s && this.#i?.type === "!" && (o = "(?:$|\\/)"), [
				a + i + o,
				P(i),
				this.#t = !!this.#t,
				this.#n
			];
		}
		let r = this.type === "*" || this.type === "+", i = this.type === "!" ? "(?:(?!(?:" : "(?:", a = this.#p(n);
		if (this.isStart() && this.isEnd() && !a && this.type !== "!") {
			let e = this.toString();
			return this.#r = [e], this.type = null, this.#t = void 0, [
				e,
				P(this.toString()),
				!1,
				!1
			];
		}
		let o = !r || t || n ? "" : this.#p(!0);
		o === a && (o = ""), o && (a = `(?:${a})(?:${o})*?`);
		let s = "";
		if (this.type === "!" && this.#u) s = (this.isStart() && !n ? F : "") + ot;
		else {
			let e = this.type === "!" ? "))" + (this.isStart() && !n && !t ? F : "") + "[^/]*?)" : this.type === "@" ? ")" : this.type === "?" ? ")?" : this.type === "+" && o ? ")" : this.type === "*" && o ? ")?" : `)${this.type}`;
			s = i + a + e;
		}
		return [
			s,
			P(a),
			this.#t = !!this.#t,
			this.#n
		];
	}
	#p(e) {
		return this.#r.map((t) => {
			/* c8 ignore start */
			if (typeof t == "string") throw Error("string type in extglob ast??");
			/* c8 ignore stop */
			let [n, r, i, a] = t.toRegExpSource(e);
			return this.#n = this.#n || a, n;
		}).filter((e) => !(this.isStart() && this.isEnd()) || !!e).join("|");
	}
	static #m(e, t, n = !1) {
		let r = !1, i = "", a = !1;
		for (let o = 0; o < e.length; o++) {
			let s = e.charAt(o);
			if (r) {
				r = !1, i += (nt.has(s) ? "\\" : "") + s;
				continue;
			}
			if (s === "\\") {
				o === e.length - 1 ? i += "\\\\" : r = !0;
				continue;
			}
			if (s === "[") {
				let [n, r, s, c] = Xe(e, o);
				if (s) {
					i += n, a ||= r, o += s - 1, t ||= c;
					continue;
				}
			}
			if (s === "*") {
				i += n && e === "*" ? ot : at, t = !0;
				continue;
			}
			if (s === "?") {
				i += it, t = !0;
				continue;
			}
			i += rt(s);
		}
		return [
			i,
			P(e),
			!!t,
			a
		];
	}
}, ct = (e, { windowsPathsNoEscape: t = !1, magicalBraces: n = !1 } = {}) => n ? t ? e.replace(/[?*()[\]{}]/g, "[$&]") : e.replace(/[?*()[\]\\{}]/g, "\\$&") : t ? e.replace(/[?*()[\]]/g, "[$&]") : e.replace(/[?*()[\]\\]/g, "\\$&"), I = (e, t, n = {}) => (M(t), !n.nocomment && t.charAt(0) === "#" ? !1 : new z(t, n).match(e)), lt = /^\*+([^+@!?\*\[\(]*)$/, ut = (e) => (t) => !t.startsWith(".") && t.endsWith(e), dt = (e) => (t) => t.endsWith(e), ft = (e) => (e = e.toLowerCase(), (t) => !t.startsWith(".") && t.toLowerCase().endsWith(e)), pt = (e) => (e = e.toLowerCase(), (t) => t.toLowerCase().endsWith(e)), mt = /^\*+\.\*+$/, ht = (e) => !e.startsWith(".") && e.includes("."), gt = (e) => e !== "." && e !== ".." && e.includes("."), _t = /^\.\*+$/, vt = (e) => e !== "." && e !== ".." && e.startsWith("."), yt = /^\*+$/, bt = (e) => e.length !== 0 && !e.startsWith("."), xt = (e) => e.length !== 0 && e !== "." && e !== "..", St = /^\?+([^+@!?\*\[\(]*)?$/, Ct = ([e, t = ""]) => {
	let n = Dt([e]);
	return t ? (t = t.toLowerCase(), (e) => n(e) && e.toLowerCase().endsWith(t)) : n;
}, wt = ([e, t = ""]) => {
	let n = Ot([e]);
	return t ? (t = t.toLowerCase(), (e) => n(e) && e.toLowerCase().endsWith(t)) : n;
}, Tt = ([e, t = ""]) => {
	let n = Ot([e]);
	return t ? (e) => n(e) && e.endsWith(t) : n;
}, Et = ([e, t = ""]) => {
	let n = Dt([e]);
	return t ? (e) => n(e) && e.endsWith(t) : n;
}, Dt = ([e]) => {
	let t = e.length;
	return (e) => e.length === t && !e.startsWith(".");
}, Ot = ([e]) => {
	let t = e.length;
	return (e) => e.length === t && e !== "." && e !== "..";
}, kt = typeof process == "object" && process ? typeof process.env == "object" && process.env && process.env.__MINIMATCH_TESTING_PLATFORM__ || process.platform : "posix", At = {
	win32: { sep: "\\" },
	posix: { sep: "/" }
};
I.sep = kt === "win32" ? At.win32.sep : At.posix.sep;
var L = Symbol("globstar **");
I.GLOBSTAR = L;
var jt = "[^/]*?", Mt = "(?:(?!(?:\\/|^)(?:\\.{1,2})($|\\/)).)*?", Nt = "(?:(?!(?:\\/|^)\\.).)*?";
I.filter = (e, t = {}) => (n) => I(n, e, t);
var R = (e, t = {}) => Object.assign({}, e, t);
I.defaults = (e) => {
	if (!e || typeof e != "object" || !Object.keys(e).length) return I;
	let t = I;
	return Object.assign((n, r, i = {}) => t(n, r, R(e, i)), {
		Minimatch: class extends t.Minimatch {
			constructor(t, n = {}) {
				super(t, R(e, n));
			}
			static defaults(n) {
				return t.defaults(R(e, n)).Minimatch;
			}
		},
		AST: class extends t.AST {
			/* c8 ignore start */
			constructor(t, n, r = {}) {
				super(t, n, R(e, r));
			}
			/* c8 ignore stop */
			static fromGlob(n, r = {}) {
				return t.AST.fromGlob(n, R(e, r));
			}
		},
		unescape: (n, r = {}) => t.unescape(n, R(e, r)),
		escape: (n, r = {}) => t.escape(n, R(e, r)),
		filter: (n, r = {}) => t.filter(n, R(e, r)),
		defaults: (n) => t.defaults(R(e, n)),
		makeRe: (n, r = {}) => t.makeRe(n, R(e, r)),
		braceExpand: (n, r = {}) => t.braceExpand(n, R(e, r)),
		match: (n, r, i = {}) => t.match(n, r, R(e, i)),
		sep: t.sep,
		GLOBSTAR: L
	});
};
var Pt = (e, t = {}) => (M(e), t.nobrace || !/\{(?:(?!\{).)*\}/.test(e) ? [e] : Ve(e));
I.braceExpand = Pt, I.makeRe = (e, t = {}) => new z(e, t).makeRe(), I.match = (e, t, n = {}) => {
	let r = new z(t, n);
	return e = e.filter((e) => r.match(e)), r.options.nonull && !e.length && e.push(t), e;
};
var Ft = /[?*]|[+@!]\(.*?\)|\[|\]/, It = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), z = class {
	options;
	set;
	pattern;
	windowsPathsNoEscape;
	nonegate;
	negate;
	comment;
	empty;
	preserveMultipleSlashes;
	partial;
	globSet;
	globParts;
	nocase;
	isWindows;
	platform;
	windowsNoMagicRoot;
	regexp;
	constructor(e, t = {}) {
		M(e), t ||= {}, this.options = t, this.pattern = e, this.platform = t.platform || kt, this.isWindows = this.platform === "win32", this.windowsPathsNoEscape = !!t.windowsPathsNoEscape || t.allowWindowsEscape === !1, this.windowsPathsNoEscape && (this.pattern = this.pattern.replace(/\\/g, "/")), this.preserveMultipleSlashes = !!t.preserveMultipleSlashes, this.regexp = null, this.negate = !1, this.nonegate = !!t.nonegate, this.comment = !1, this.empty = !1, this.partial = !!t.partial, this.nocase = !!this.options.nocase, this.windowsNoMagicRoot = t.windowsNoMagicRoot === void 0 ? !!(this.isWindows && this.nocase) : t.windowsNoMagicRoot, this.globSet = [], this.globParts = [], this.set = [], this.make();
	}
	hasMagic() {
		if (this.options.magicalBraces && this.set.length > 1) return !0;
		for (let e of this.set) for (let t of e) if (typeof t != "string") return !0;
		return !1;
	}
	debug(...e) {}
	make() {
		let e = this.pattern, t = this.options;
		if (!t.nocomment && e.charAt(0) === "#") {
			this.comment = !0;
			return;
		}
		if (!e) {
			this.empty = !0;
			return;
		}
		this.parseNegate(), this.globSet = [...new Set(this.braceExpand())], t.debug && (this.debug = (...e) => console.error(...e)), this.debug(this.pattern, this.globSet);
		let n = this.globSet.map((e) => this.slashSplit(e));
		this.globParts = this.preprocess(n), this.debug(this.pattern, this.globParts);
		let r = this.globParts.map((e, t, n) => {
			if (this.isWindows && this.windowsNoMagicRoot) {
				let t = e[0] === "" && e[1] === "" && (e[2] === "?" || !Ft.test(e[2])) && !Ft.test(e[3]), n = /^[a-z]:/i.test(e[0]);
				if (t) return [...e.slice(0, 4), ...e.slice(4).map((e) => this.parse(e))];
				if (n) return [e[0], ...e.slice(1).map((e) => this.parse(e))];
			}
			return e.map((e) => this.parse(e));
		});
		if (this.debug(this.pattern, r), this.set = r.filter((e) => e.indexOf(!1) === -1), this.isWindows) for (let e = 0; e < this.set.length; e++) {
			let t = this.set[e];
			t[0] === "" && t[1] === "" && this.globParts[e][2] === "?" && typeof t[3] == "string" && /^[a-z]:$/i.test(t[3]) && (t[2] = "?");
		}
		this.debug(this.pattern, this.set);
	}
	preprocess(e) {
		if (this.options.noglobstar) for (let t = 0; t < e.length; t++) for (let n = 0; n < e[t].length; n++) e[t][n] === "**" && (e[t][n] = "*");
		let { optimizationLevel: t = 1 } = this.options;
		return t >= 2 ? (e = this.firstPhasePreProcess(e), e = this.secondPhasePreProcess(e)) : e = t >= 1 ? this.levelOneOptimize(e) : this.adjascentGlobstarOptimize(e), e;
	}
	adjascentGlobstarOptimize(e) {
		return e.map((e) => {
			let t = -1;
			for (; (t = e.indexOf("**", t + 1)) !== -1;) {
				let n = t;
				for (; e[n + 1] === "**";) n++;
				n !== t && e.splice(t, n - t);
			}
			return e;
		});
	}
	levelOneOptimize(e) {
		return e.map((e) => (e = e.reduce((e, t) => {
			let n = e[e.length - 1];
			return t === "**" && n === "**" ? e : t === ".." && n && n !== ".." && n !== "." && n !== "**" ? (e.pop(), e) : (e.push(t), e);
		}, []), e.length === 0 ? [""] : e));
	}
	levelTwoFileOptimize(e) {
		Array.isArray(e) || (e = this.slashSplit(e));
		let t = !1;
		do {
			if (t = !1, !this.preserveMultipleSlashes) {
				for (let n = 1; n < e.length - 1; n++) {
					let r = e[n];
					(n !== 1 || r !== "" || e[0] !== "") && (r === "." || r === "") && (t = !0, e.splice(n, 1), n--);
				}
				e[0] === "." && e.length === 2 && (e[1] === "." || e[1] === "") && (t = !0, e.pop());
			}
			let n = 0;
			for (; (n = e.indexOf("..", n + 1)) !== -1;) {
				let r = e[n - 1];
				r && r !== "." && r !== ".." && r !== "**" && (t = !0, e.splice(n - 1, 2), n -= 2);
			}
		} while (t);
		return e.length === 0 ? [""] : e;
	}
	firstPhasePreProcess(e) {
		let t = !1;
		do {
			t = !1;
			for (let n of e) {
				let r = -1;
				for (; (r = n.indexOf("**", r + 1)) !== -1;) {
					let i = r;
					for (; n[i + 1] === "**";) i++;
					i > r && n.splice(r + 1, i - r);
					let a = n[r + 1], o = n[r + 2], s = n[r + 3];
					if (a !== ".." || !o || o === "." || o === ".." || !s || s === "." || s === "..") continue;
					t = !0, n.splice(r, 1);
					let c = n.slice(0);
					c[r] = "**", e.push(c), r--;
				}
				if (!this.preserveMultipleSlashes) {
					for (let e = 1; e < n.length - 1; e++) {
						let r = n[e];
						(e !== 1 || r !== "" || n[0] !== "") && (r === "." || r === "") && (t = !0, n.splice(e, 1), e--);
					}
					n[0] === "." && n.length === 2 && (n[1] === "." || n[1] === "") && (t = !0, n.pop());
				}
				let i = 0;
				for (; (i = n.indexOf("..", i + 1)) !== -1;) {
					let e = n[i - 1];
					if (e && e !== "." && e !== ".." && e !== "**") {
						t = !0;
						let e = i === 1 && n[i + 1] === "**" ? ["."] : [];
						n.splice(i - 1, 2, ...e), n.length === 0 && n.push(""), i -= 2;
					}
				}
			}
		} while (t);
		return e;
	}
	secondPhasePreProcess(e) {
		for (let t = 0; t < e.length - 1; t++) for (let n = t + 1; n < e.length; n++) {
			let r = this.partsMatch(e[t], e[n], !this.preserveMultipleSlashes);
			if (r) {
				e[t] = [], e[n] = r;
				break;
			}
		}
		return e.filter((e) => e.length);
	}
	partsMatch(e, t, n = !1) {
		let r = 0, i = 0, a = [], o = "";
		for (; r < e.length && i < t.length;) if (e[r] === t[i]) a.push(o === "b" ? t[i] : e[r]), r++, i++;
		else if (n && e[r] === "**" && t[i] === e[r + 1]) a.push(e[r]), r++;
		else if (n && t[i] === "**" && e[r] === t[i + 1]) a.push(t[i]), i++;
		else if (e[r] === "*" && t[i] && (this.options.dot || !t[i].startsWith(".")) && t[i] !== "**") {
			if (o === "b") return !1;
			o = "a", a.push(e[r]), r++, i++;
		} else if (t[i] === "*" && e[r] && (this.options.dot || !e[r].startsWith(".")) && e[r] !== "**") {
			if (o === "a") return !1;
			o = "b", a.push(t[i]), r++, i++;
		} else return !1;
		return e.length === t.length && a;
	}
	parseNegate() {
		if (this.nonegate) return;
		let e = this.pattern, t = !1, n = 0;
		for (let r = 0; r < e.length && e.charAt(r) === "!"; r++) t = !t, n++;
		n && (this.pattern = e.slice(n)), this.negate = t;
	}
	matchOne(e, t, n = !1) {
		let r = this.options;
		if (this.isWindows) {
			let n = typeof e[0] == "string" && /^[a-z]:$/i.test(e[0]), r = !n && e[0] === "" && e[1] === "" && e[2] === "?" && /^[a-z]:$/i.test(e[3]), i = typeof t[0] == "string" && /^[a-z]:$/i.test(t[0]), a = !i && t[0] === "" && t[1] === "" && t[2] === "?" && typeof t[3] == "string" && /^[a-z]:$/i.test(t[3]), o = r ? 3 : n ? 0 : void 0, s = a ? 3 : i ? 0 : void 0;
			if (typeof o == "number" && typeof s == "number") {
				let [n, r] = [e[o], t[s]];
				n.toLowerCase() === r.toLowerCase() && (t[s] = n, s > o ? t = t.slice(s) : o > s && (e = e.slice(o)));
			}
		}
		let { optimizationLevel: i = 1 } = this.options;
		i >= 2 && (e = this.levelTwoFileOptimize(e)), this.debug("matchOne", this, {
			file: e,
			pattern: t
		}), this.debug("matchOne", e.length, t.length);
		for (var a = 0, o = 0, s = e.length, c = t.length; a < s && o < c; a++, o++) {
			this.debug("matchOne loop");
			var l = t[o], u = e[a];
			/* c8 ignore start */
			if (this.debug(t, l, u), l === !1) return !1;
			/* c8 ignore stop */
			if (l === L) {
				this.debug("GLOBSTAR", [
					t,
					l,
					u
				]);
				var d = a, f = o + 1;
				if (f === c) {
					for (this.debug("** at the end"); a < s; a++) if (e[a] === "." || e[a] === ".." || !r.dot && e[a].charAt(0) === ".") return !1;
					return !0;
				}
				for (; d < s;) {
					var p = e[d];
					if (this.debug("\nglobstar while", e, d, t, f, p), this.matchOne(e.slice(d), t.slice(f), n)) return this.debug("globstar found match!", d, s, p), !0;
					if (p === "." || p === ".." || !r.dot && p.charAt(0) === ".") {
						this.debug("dot detected!", e, d, t, f);
						break;
					}
					this.debug("globstar swallow a segment, and continue"), d++;
				}
				/* c8 ignore stop */
				return !!(n && (this.debug("\n>>> no match, partial?", e, d, t, f), d === s));
			}
			let i;
			if (typeof l == "string" ? (i = u === l, this.debug("string match", l, u, i)) : (i = l.test(u), this.debug("pattern match", l, u, i)), !i) return !1;
		}
		if (a === s && o === c) return !0;
		if (a === s) return n;
		if (o === c) return a === s - 1 && e[a] === "";
		throw Error("wtf?");
		/* c8 ignore stop */
	}
	braceExpand() {
		return Pt(this.pattern, this.options);
	}
	parse(e) {
		M(e);
		let t = this.options;
		if (e === "**") return L;
		if (e === "") return "";
		let n, r = null;
		(n = e.match(yt)) ? r = t.dot ? xt : bt : (n = e.match(lt)) ? r = (t.nocase ? t.dot ? pt : ft : t.dot ? dt : ut)(n[1]) : (n = e.match(St)) ? r = (t.nocase ? t.dot ? wt : Ct : t.dot ? Tt : Et)(n) : (n = e.match(mt)) ? r = t.dot ? gt : ht : (n = e.match(_t)) && (r = vt);
		let i = st.fromGlob(e, this.options).toMMPattern();
		return r && typeof i == "object" && Reflect.defineProperty(i, "test", { value: r }), i;
	}
	makeRe() {
		if (this.regexp || this.regexp === !1) return this.regexp;
		let e = this.set;
		if (!e.length) return this.regexp = !1, this.regexp;
		let t = this.options, n = t.noglobstar ? jt : t.dot ? Mt : Nt, r = new Set(t.nocase ? ["i"] : []), i = e.map((e) => {
			let t = e.map((e) => {
				if (e instanceof RegExp) for (let t of e.flags.split("")) r.add(t);
				return typeof e == "string" ? It(e) : e === L ? L : e._src;
			});
			t.forEach((e, r) => {
				let i = t[r + 1], a = t[r - 1];
				e === L && a !== L && (a === void 0 ? i !== void 0 && i !== L ? t[r + 1] = "(?:\\/|" + n + "\\/)?" + i : t[r] = n : i === void 0 ? t[r - 1] = a + "(?:\\/|\\/" + n + ")?" : i !== L && (t[r - 1] = a + "(?:\\/|\\/" + n + "\\/)" + i, t[r + 1] = L));
			});
			let i = t.filter((e) => e !== L);
			if (this.partial && i.length >= 1) {
				let e = [];
				for (let t = 1; t <= i.length; t++) e.push(i.slice(0, t).join("/"));
				return "(?:" + e.join("|") + ")";
			}
			return i.join("/");
		}).join("|"), [a, o] = e.length > 1 ? ["(?:", ")"] : ["", ""];
		i = "^" + a + i + o + "$", this.partial && (i = "^(?:\\/|" + a + i.slice(1, -1) + o + ")$"), this.negate && (i = "^(?!" + i + ").+$");
		try {
			this.regexp = new RegExp(i, [...r].join(""));
		} catch {
			this.regexp = !1;
		}
		/* c8 ignore stop */
		return this.regexp;
	}
	slashSplit(e) {
		return this.preserveMultipleSlashes ? e.split("/") : this.isWindows && /^\/\/[^\/]+/.test(e) ? ["", ...e.split(/\/+/)] : e.split(/\/+/);
	}
	match(e, t = this.partial) {
		if (this.debug("match", e, this.pattern), this.comment) return !1;
		if (this.empty) return e === "";
		if (e === "/" && t) return !0;
		let n = this.options;
		this.isWindows && (e = e.split("\\").join("/"));
		let r = this.slashSplit(e);
		this.debug(this.pattern, "split", r);
		let i = this.set;
		this.debug(this.pattern, "set", i);
		let a = r[r.length - 1];
		if (!a) for (let e = r.length - 2; !a && e >= 0; e--) a = r[e];
		for (let e = 0; e < i.length; e++) {
			let o = i[e], s = r;
			if (n.matchBase && o.length === 1 && (s = [a]), this.matchOne(s, o, t)) return n.flipNegate ? !0 : !this.negate;
		}
		return !n.flipNegate && this.negate;
	}
	static defaults(e) {
		return I.defaults(e).Minimatch;
	}
};
I.AST = st, I.Minimatch = z, I.escape = ct, I.unescape = P;
//#endregion
//#region ../auto-tracer-filter-utils/dist/matchesPattern.js
function B(e, t) {
	return t instanceof RegExp ? t.test(e) : t.includes("*") || t.includes("?") || t.includes("[") ? I(e, t) : e === t;
}
//#endregion
//#region src/redaction/isRedactionNameMatched.ts
function V(e, t) {
	let n = e.toLowerCase();
	return t.some((e) => B(n, e.toLowerCase()));
}
//#endregion
//#region src/redaction/redactJsonFields.ts
function H(e, t) {
	if (Array.isArray(e)) return e.map((e) => H(e, t));
	if (typeof e != "object" || !e) return e;
	let n = {};
	for (let [r, i] of Object.entries(e)) n[r] = V(r, t) ? "[REDACTED]" : H(i, t);
	return n;
}
//#endregion
//#region src/body/parseJsonBodyText.ts
function Lt(e) {
	try {
		return {
			status: "parsed",
			value: JSON.parse(e)
		};
	} catch {
		return {
			status: "invalid-json",
			rawText: e,
			fieldRedactionApplied: !1
		};
	}
}
//#endregion
//#region src/body/createJsonBodySnapshot.ts
function Rt(e, t) {
	let n = Lt(e);
	return n.status === "invalid-json" ? n : {
		status: "parsed",
		value: H(n.value, t)
	};
}
//#endregion
//#region src/body/createOversizedJsonBodySnapshot.ts
function zt(e, t) {
	return {
		status: "exceeds-limit",
		contentType: e,
		byteSize: t,
		reason: "JSON body exceeds capture limit"
	};
}
//#endregion
//#region src/body/isBodyWithinCaptureLimit.ts
function Bt(e, t) {
	return e <= t;
}
//#endregion
//#region src/body/createTextBodySnapshot.ts
function Vt(e) {
	let t = e.contentType ?? "";
	if (xe(e.text, t) !== "json") return _e(e.text, e.captureLimit);
	let n = new TextEncoder().encode(e.text).byteLength;
	return Bt(n, e.captureLimit) ? Rt(e.text, e.redactionPatterns) : zt(t, n);
}
//#endregion
//#region src/body/createBodySnapshot.ts
function Ht(e) {
	return typeof e.body == "string" ? Vt({
		text: e.body,
		contentType: e.contentType,
		captureLimit: e.captureLimit,
		redactionPatterns: e.redactionPatterns
	}) : be({
		body: e.body,
		contentType: e.contentType,
		captureLimit: e.captureLimit
	});
}
//#endregion
//#region src/output/cloneStructuredSnapshot.ts
function Ut(e) {
	return structuredClone(e);
}
//#endregion
//#region src/events/createStructuredDetailEvent.ts
function U(e, t, n) {
	return {
		kind: "structured-detail",
		tokens: [
			{
				role: "identity",
				text: `Network #${e}`
			},
			{
				role: "plain",
				text: "   "
			},
			{
				role: "label",
				text: t
			},
			{
				role: "plain",
				text: ": "
			}
		],
		value: Ut(n)
	};
}
//#endregion
//#region src/capture/createRequestBodyDetailEvent.ts
function W(e, t, n) {
	return U(e, "request body", Ht({
		body: t,
		contentType: n.contentType,
		captureLimit: n.bodyCaptureLimit,
		redactionPatterns: n.redactionPatterns
	}));
}
//#endregion
//#region src/capture/createRequestBodyCaptureTask.ts
async function Wt(e, t, n) {
	let r = me(t);
	if (r === void 0) return T(e, "request body");
	try {
		return W(e, await r.text(), {
			contentType: E(r.headers),
			bodyCaptureLimit: n.bodyCaptureLimit,
			redactionPatterns: n.redactionPatterns
		});
	} catch {
		return T(e, "request body");
	}
}
//#endregion
//#region src/redaction/redactHeaders.ts
function G(e, t) {
	let n = new Headers(e);
	for (let e of n.keys()) V(e, t) && n.set(e, "[REDACTED]");
	return n;
}
//#endregion
//#region src/capture/createRequestHeadersDetailEvent.ts
function Gt(e, t, n) {
	let r = G(t, n);
	return U(e, "request headers", Object.fromEntries(r.entries()));
}
//#endregion
//#region src/capture/emitPendingDetail.ts
function Kt(e, t) {
	if (t.canEmitPendingOutput()) try {
		t.emit(e);
	} catch {
		return;
	}
}
//#endregion
//#region src/capture/runPendingDetailCapture.ts
function K(e, t) {
	t.beginPendingWork();
	try {
		Kt(e(), t);
	} catch {
		return;
	} finally {
		t.settlePendingWork();
	}
}
//#endregion
//#region src/capture/startPendingDetailTask.ts
function q(e, t) {
	t.beginPendingWork();
	let n;
	try {
		n = e();
	} catch {
		return t.settlePendingWork(), Promise.resolve();
	}
	return n.then((e) => Kt(e, t), () => {}).finally(t.settlePendingWork);
}
//#endregion
//#region src/capture/startRequestBodyCapture.ts
function qt(e, t, n) {
	return q(() => Wt(e, t, n), n);
}
//#endregion
//#region src/capture/startFetchRequestBodyCapture.ts
function Jt(e, t, n) {
	let r = t.init?.body;
	return r == null ? t.input instanceof Request && t.input.body !== null ? qt(e, t.input, n) : Promise.resolve() : (K(() => W(e, r, n), n), Promise.resolve());
}
//#endregion
//#region src/capture/startRequestHeadersCapture.ts
function Yt(e, t, n) {
	K(() => Gt(e, t, n.redactionPatterns), n);
}
//#endregion
//#region src/capture/startFetchRequestDetails.ts
function Xt(e, t, n) {
	n.capture.captureRequestHeaders && Yt(e, n.metadata.headers, {
		...n,
		redactionPatterns: n.capture.redactionPatterns
	}), n.capture.captureRequestBody && Jt(e, t, {
		...n,
		contentType: n.metadata.contentType,
		bodyCaptureLimit: n.capture.bodyCaptureLimit,
		redactionPatterns: n.capture.redactionPatterns
	});
}
//#endregion
//#region src/capture/cloneResponseForBodyCapture.ts
function Zt(e) {
	try {
		return e.clone();
	} catch {
		return;
	}
}
//#endregion
//#region src/capture/createResponseBodyDetailEvent.ts
function Qt(e, t, n) {
	return U(e, "response body", Ht({
		body: t,
		contentType: n.contentType,
		captureLimit: n.bodyCaptureLimit,
		redactionPatterns: n.redactionPatterns
	}));
}
//#endregion
//#region src/capture/createResponseBodyCaptureTask.ts
async function $t(e, t, n) {
	let r = Zt(t);
	if (r === void 0) return T(e, "response body");
	try {
		return Qt(e, await r.text(), {
			contentType: E(r.headers),
			bodyCaptureLimit: n.bodyCaptureLimit,
			redactionPatterns: n.redactionPatterns
		});
	} catch {
		return T(e, "response body");
	}
}
//#endregion
//#region src/capture/createResponseHeadersSnapshot.ts
function en(e) {
	return new Headers(e.headers);
}
//#endregion
//#region src/capture/createResponseHeadersDetailEvent.ts
function tn(e, t, n) {
	let r = G(en(t), n);
	return U(e, "response headers", Object.fromEntries(r.entries()));
}
//#endregion
//#region src/capture/startResponseBodyCapture.ts
function nn(e, t, n) {
	return q(() => $t(e, t, n), n);
}
//#endregion
//#region src/capture/startResponseHeadersCapture.ts
function rn(e, t, n) {
	K(() => tn(e, t, n.redactionPatterns), n);
}
//#endregion
//#region src/capture/startFetchResponseDetails.ts
function an(e, t, n) {
	n.capture.captureResponseHeaders && rn(e, t, {
		...n,
		redactionPatterns: n.capture.redactionPatterns
	}), n.capture.captureResponseBody && nn(e, t, {
		...n,
		bodyCaptureLimit: n.capture.bodyCaptureLimit,
		redactionPatterns: n.capture.redactionPatterns
	});
}
//#endregion
//#region src/filtering/normalizeRequestedUrl.ts
function on(e, t) {
	return new URL(e, t).toString();
}
//#endregion
//#region src/filtering/isNetworkRequestIncluded.ts
function sn(e, t, n) {
	return n.some((t) => B(e, t)) ? !1 : t.length === 0 || t.some((t) => B(e, t));
}
//#endregion
//#region src/identity/updateIncludedAdmissionCount.ts
function cn(e, t) {
	return t ? e + 1 : e;
}
//#endregion
//#region src/automatic-stop/hasReachedAutomaticStopLimit.ts
function ln(e, t) {
	return t !== void 0 && e >= t;
}
//#endregion
//#region src/automatic-stop/shouldAdmitIncludedRequest.ts
function un(e, t) {
	return t === void 0 || e < t;
}
//#endregion
//#region src/automatic-stop/getIncludedRequestAdmissionTransition.ts
function dn(e, t) {
	if (!un(e, t)) return {
		admitted: !1,
		admittedRequestCount: e,
		automaticStopTriggered: !1
	};
	let n = cn(e, !0);
	return {
		admitted: !0,
		admittedRequestCount: n,
		automaticStopTriggered: ln(n, t)
	};
}
//#endregion
//#region src/automatic-stop/getNetworkRequestAdmission.ts
function fn(e, t, n) {
	return sn(e, t.includePatterns, t.excludePatterns) ? {
		included: !0,
		...dn(n.admittedRequestCount, n.autoStopLimit)
	} : {
		included: !1,
		admitted: !1,
		admittedRequestCount: n.admittedRequestCount,
		automaticStopTriggered: !1
	};
}
//#endregion
//#region src/identity/allocateNetworkRequestAdmission.ts
function pn(e, t, n) {
	return {
		requestId: e(),
		...fn(t, n.filters, {
			admittedRequestCount: n.admittedRequestCount,
			autoStopLimit: n.autoStopLimit
		})
	};
}
//#endregion
//#region src/presentation/formatDisplayUrl.ts
function mn(e, t, n = []) {
	let r = new URL(e), i = new URL(t);
	for (let e of r.searchParams.keys()) V(e, n) && r.searchParams.set(e, "[REDACTED]");
	let a = r.toString().replaceAll("%5BREDACTED%5D", "[REDACTED]");
	return r.origin === i.origin ? a.slice(r.origin.length) : a;
}
//#endregion
//#region src/transport/getFetchRequestedUrl.ts
function hn(e) {
	return e instanceof Request ? e.url : e instanceof URL ? e.href : e;
}
//#endregion
//#region src/transport/allocateFetchRequestAdmission.ts
function gn(e, t, n) {
	let r = on(hn(t), n.baseUrl);
	return {
		requestedUrl: mn(r, n.baseUrl, n.redactionPatterns),
		normalizedRequestedUrl: r,
		...pn(e, r, {
			filters: {
				includePatterns: n.includePatterns,
				excludePatterns: n.excludePatterns
			},
			admittedRequestCount: n.admittedRequestCount,
			autoStopLimit: n.autoStopLimit
		})
	};
}
//#endregion
//#region src/transport/createEffectiveFetchHeadersSnapshot.ts
function _n(e, t) {
	return t?.headers === void 0 ? e instanceof Request ? new Headers(e.headers) : new Headers() : new Headers(t.headers);
}
//#endregion
//#region src/transport/normalizeHttpMethod.ts
function vn(e) {
	let t = e.toUpperCase();
	return [
		"DELETE",
		"GET",
		"HEAD",
		"OPTIONS",
		"POST",
		"PUT"
	].some((e) => e === t) ? t : e;
}
//#endregion
//#region src/transport/getEffectiveFetchMethod.ts
function yn(e, t) {
	return vn(t?.method ?? (e instanceof Request ? e.method : "GET"));
}
//#endregion
//#region src/transport/createFetchRequestMetadata.ts
function bn(e, t) {
	let n = _n(e, t);
	return {
		method: yn(e, t),
		requestedUrl: hn(e),
		headers: n,
		contentType: E(n)
	};
}
//#endregion
//#region src/events/createRequestStartEvent.ts
function xn(e, t, n) {
	return {
		kind: "start",
		tokens: [
			{
				role: "identity",
				text: `Network #${e}`
			},
			{
				role: "direction",
				text: " -> "
			},
			{
				role: "method",
				text: t
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "url",
				text: n
			}
		]
	};
}
//#endregion
//#region src/timing/calculateElapsedDuration.ts
function J(e, t) {
	return t - e;
}
//#endregion
//#region src/timing/formatElapsedDuration.ts
function Y(e) {
	return e < 1e3 ? `${e} ms` : `${(e / 1e3).toFixed(2)} s`;
}
//#endregion
//#region src/events/createFailedCompletionEvent.ts
function Sn(e) {
	return {
		kind: "failed-completion",
		tokens: [
			{
				role: "identity",
				text: `Network #${e.requestId}`
			},
			{
				role: "direction",
				text: " <- "
			},
			{
				role: "outcome",
				text: "FAILED"
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "method",
				text: e.method
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "url",
				text: e.url
			},
			{
				role: "plain",
				text: " ("
			},
			{
				role: "duration",
				text: Y(e.elapsedMilliseconds)
			},
			{
				role: "plain",
				text: ")"
			}
		]
	};
}
//#endregion
//#region src/outcomes/extractFailureDetail.ts
function Cn(e) {
	if (typeof e != "object" || !e) return;
	let t = Reflect.get(e, "name"), n = Reflect.get(e, "message");
	if (typeof t == "string" && typeof n == "string") return {
		name: t,
		message: n
	};
}
//#endregion
//#region src/transport/createFetchRejectionEvents.ts
function wn(e) {
	let t = Sn({
		requestId: e.requestId,
		method: e.method,
		url: e.requestedUrl,
		elapsedMilliseconds: e.elapsedMilliseconds
	}), n = Cn(e.failure);
	return n === void 0 ? { completion: t } : {
		completion: t,
		failureDetail: U(e.requestId, "failure", n)
	};
}
//#endregion
//#region src/transport/createTimedFetchRejectionEvents.ts
function Tn(e) {
	return wn({
		requestId: e.requestId,
		method: e.method,
		requestedUrl: e.requestedUrl,
		elapsedMilliseconds: J(e.startMarker, e.completionMarker),
		failure: e.failure
	});
}
//#endregion
//#region src/transport/emitFetchRejectionEvents.ts
function En(e, t) {
	t(e.completion), e.failureDetail !== void 0 && t(e.failureDetail);
}
//#endregion
//#region src/transport/createFetchRejectionObserver.ts
function Dn(e) {
	return (t) => En(Tn({
		requestId: e.requestId,
		method: e.method,
		requestedUrl: e.requestedUrl,
		startMarker: e.startMarker,
		completionMarker: e.getCompletionMarker(),
		failure: t
	}), e.emit);
}
//#endregion
//#region src/events/createHttpCompletionEvent.ts
function On(e) {
	return {
		kind: "http-completion",
		tokens: [
			{
				role: "identity",
				text: `Network #${e.requestId}`
			},
			{
				role: "direction",
				text: " <- "
			},
			{
				role: "status",
				text: String(e.status)
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "method",
				text: e.method
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "url",
				text: e.url
			},
			{
				role: "plain",
				text: " ("
			},
			{
				role: "duration",
				text: Y(e.elapsedMilliseconds)
			},
			{
				role: "plain",
				text: ")"
			}
		]
	};
}
//#endregion
//#region src/events/createRedirectCompletionEvent.ts
function kn(e) {
	return {
		kind: "redirect-completion",
		completionTokens: [
			{
				role: "identity",
				text: `Network #${e.requestId}`
			},
			{
				role: "direction",
				text: " <- "
			},
			{
				role: "status",
				text: String(e.status)
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "redirect",
				text: "REDIRECTED"
			},
			{
				role: "plain",
				text: " ("
			},
			{
				role: "duration",
				text: Y(e.elapsedMilliseconds)
			},
			{
				role: "plain",
				text: ")"
			}
		],
		requestedTokens: [
			{
				role: "plain",
				text: "  "
			},
			{
				role: "label",
				text: "requested"
			},
			{
				role: "plain",
				text: ": "
			},
			{
				role: "method",
				text: e.method
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "url",
				text: e.requestedUrl
			}
		],
		finalTokens: [
			{
				role: "plain",
				text: "  "
			},
			{
				role: "label",
				text: "final"
			},
			{
				role: "plain",
				text: ":     "
			},
			{
				role: "url",
				text: e.finalUrl
			}
		]
	};
}
//#endregion
//#region src/redirects/getFetchRedirectUrl.ts
function An(e, t) {
	return e ? t : void 0;
}
//#endregion
//#region src/transport/createFetchCompletionEvent.ts
function jn(e) {
	let t = An(e.redirected, e.responseUrl);
	return t === void 0 ? On({
		requestId: e.requestId,
		status: e.status,
		method: e.method,
		url: e.requestedUrl,
		elapsedMilliseconds: e.elapsedMilliseconds
	}) : kn({
		requestId: e.requestId,
		status: e.status,
		method: e.method,
		requestedUrl: e.requestedUrl,
		finalUrl: t,
		elapsedMilliseconds: e.elapsedMilliseconds
	});
}
//#endregion
//#region src/transport/createFetchResponseEvent.ts
function Mn(e) {
	return jn({
		requestId: e.requestId,
		status: e.response.status,
		method: e.method,
		requestedUrl: e.requestedUrl,
		responseUrl: e.response.url,
		redirected: e.response.redirected,
		elapsedMilliseconds: J(e.startMarker, e.completionMarker)
	});
}
//#endregion
//#region src/transport/createFetchResponseObserver.ts
function Nn(e) {
	return (t) => e.emit(Mn({
		requestId: e.requestId,
		method: e.method,
		requestedUrl: e.requestedUrl,
		startMarker: e.startMarker,
		completionMarker: e.getCompletionMarker(),
		response: t
	}));
}
//#endregion
//#region src/transport/createFetchOutcomeObservers.ts
function Pn(e) {
	let t = Dn(e);
	return {
		onResolved: Nn(e),
		onRejected: t,
		onSynchronousFailure: t
	};
}
//#endregion
//#region src/transport/createSettlingFetchOutcomeObservers.ts
function Fn(e) {
	let t = Pn(e);
	function n(n) {
		try {
			e.canEmitPendingOutput() && (t.onResolved(n), e.startResponseDetails?.(n));
		} finally {
			e.settlePendingWork();
		}
	}
	function r(n) {
		try {
			e.canEmitPendingOutput() && t.onRejected(n);
		} finally {
			e.settlePendingWork();
		}
	}
	return {
		onResolved: n,
		onRejected: r,
		onSynchronousFailure: r
	};
}
//#endregion
//#region src/transport/invokeTransportWithFailureObserver.ts
function In(e, t) {
	try {
		return e();
	} catch (e) {
		try {
			t(e);
		} catch {}
		throw e;
	}
}
//#endregion
//#region src/transport/invokeNativeFetch.ts
function X(e, t) {
	return t.hasInit ?? t.init !== void 0 ? e(t.input, t.init) : e(t.input);
}
//#endregion
//#region src/transport/observeFetchPromise.ts
function Ln(e, t, n) {
	return e.then(t, n).catch(() => {}), e;
}
//#endregion
//#region src/transport/invokeObservedFetch.ts
function Rn(e, t, n) {
	return Ln(In(() => X(e, t), n.onSynchronousFailure), n.onResolved, n.onRejected);
}
//#endregion
//#region src/transport/invokeTracedFetchRequest.ts
function zn(e, t, n) {
	return n.beginPendingWork(), n.emit(xn(n.requestId, n.method, n.requestedUrl)), n.startRequestDetails?.(), Rn(e, t, Fn(n));
}
//#endregion
//#region src/transport/invokeFetchByAdmission.ts
function Bn(e, t, n) {
	return n.admitted ? zn(e, t, n) : X(e, t);
}
//#endregion
//#region src/transport/invokeFetchRequest.ts
function Vn(e, t, n) {
	if (!n.isEnabled()) return X(e, t);
	let r = n.getConfig(), i = gn(n.getNextRequestId, t.input, {
		baseUrl: n.baseUrl,
		redactionPatterns: r.redactionPatterns,
		includePatterns: r.includePatterns,
		excludePatterns: r.excludePatterns,
		admittedRequestCount: n.getAdmittedRequestCount(),
		autoStopLimit: r.autoStopAfterRequests
	});
	if (fe(i, n.setAdmittedRequestCount, n.enterStopping), !i.admitted) return X(e, t);
	let a = bn(t.input, t.init), o = pe(r);
	return Bn(e, t, {
		admitted: !0,
		requestId: i.requestId,
		method: a.method,
		requestedUrl: i.requestedUrl,
		startMarker: n.getMonotonicMarker(),
		getCompletionMarker: n.getMonotonicMarker,
		beginPendingWork: n.beginPendingWork,
		startRequestDetails: () => Xt(i.requestId, t, {
			metadata: a,
			capture: o,
			beginPendingWork: n.beginPendingWork,
			canEmitPendingOutput: n.canEmitPendingOutput,
			emit: n.emit,
			settlePendingWork: n.settlePendingWork
		}),
		startResponseDetails: (e) => an(i.requestId, e, {
			capture: o,
			beginPendingWork: n.beginPendingWork,
			canEmitPendingOutput: n.canEmitPendingOutput,
			emit: n.emit,
			settlePendingWork: n.settlePendingWork
		}),
		canEmitPendingOutput: n.canEmitPendingOutput,
		settlePendingWork: n.settlePendingWork,
		emit: n.emit
	});
}
//#endregion
//#region src/transport/createFetchWrapperHandler.ts
function Hn(e) {
	function t(t, ...n) {
		return Vn(t, n.length === 1 ? { input: n[0] } : {
			input: n[0],
			init: n[1],
			hasInit: !0
		}, e);
	}
	return t;
}
//#endregion
//#region src/transport/createXhrInstanceStateStore.ts
function Un() {
	let e, t;
	function n() {
		return e;
	}
	function r(t) {
		e = t;
	}
	function i() {
		return t;
	}
	function a(e) {
		t = e;
	}
	function o() {
		t = void 0;
	}
	return {
		getOpenMetadata: n,
		setOpenMetadata: r,
		getActiveRequest: i,
		setActiveRequest: a,
		clearActiveRequest: o
	};
}
//#endregion
//#region src/transport/createXhrRequestHeadersStore.ts
function Wn() {
	let e = new Headers();
	function t() {
		return new Headers(e);
	}
	function n(t, n) {
		e.append(t, n);
	}
	function r() {
		e = new Headers();
	}
	return {
		getRequestHeaders: t,
		appendRequestHeader: n,
		clearRequestHeaders: r
	};
}
//#endregion
//#region src/transport/createXhrInstanceStoreRegistry.ts
function Gn() {
	let e = /* @__PURE__ */ new WeakMap();
	function t(t) {
		let n = e.get(t);
		if (n !== void 0) return n;
		let r = {
			...Un(),
			...Wn()
		};
		return e.set(t, r), r;
	}
	return { getInstanceStore: t };
}
//#endregion
//#region src/transport/invokeObservedXhrOpen.ts
function Kn(e, t, n) {
	e(...t);
	try {
		n();
	} catch {}
}
//#endregion
//#region src/transport/createXhrOpenMetadata.ts
function qn(e) {
	return {
		method: vn(e.method),
		requestedUrl: e.requestedUrl,
		async: e.async ?? !0
	};
}
//#endregion
//#region src/events/createAbortedCompletionEvent.ts
function Jn(e) {
	return {
		kind: "aborted-completion",
		tokens: [
			{
				role: "identity",
				text: `Network #${e.requestId}`
			},
			{
				role: "direction",
				text: " <- "
			},
			{
				role: "outcome",
				text: "ABORTED"
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "method",
				text: e.method
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "url",
				text: e.url
			},
			{
				role: "plain",
				text: " ("
			},
			{
				role: "duration",
				text: Y(e.elapsedMilliseconds)
			},
			{
				role: "plain",
				text: ")"
			}
		]
	};
}
//#endregion
//#region src/transport/finalizeReplacedXhrRequest.ts
function Yn(e, t, n) {
	if (e.claimTerminalOutcome()) try {
		n(Jn({
			requestId: e.requestId,
			method: e.method,
			url: e.requestedUrl,
			elapsedMilliseconds: J(e.startMarker, t)
		}));
	} catch {} finally {
		e.settlePendingWork();
	}
}
//#endregion
//#region src/transport/replaceActiveXhrRequest.ts
function Xn(e, t, n) {
	e.removeTerminalListeners(), Yn(e, t, n);
}
//#endregion
//#region src/transport/recordXhrOpen.ts
function Zn(e, t, n) {
	let r = t.getActiveRequest();
	r !== void 0 && (Xn(r, n.getCompletionMarker(), n.emit), t.clearActiveRequest()), t.setOpenMetadata(qn(e));
}
//#endregion
//#region src/transport/invokeXhrOpenRequest.ts
function Qn(e, t, n) {
	function r() {
		let e = t.length === 2 ? {
			method: t[0],
			requestedUrl: String(t[1])
		} : {
			method: t[0],
			requestedUrl: String(t[1]),
			async: t[2]
		};
		n.clearRequestHeaders(), Zn(e, n, n);
	}
	Kn(e, t, r);
}
//#endregion
//#region src/capture/isXhrDocumentBody.ts
function $n(e) {
	return typeof Document < "u" && e instanceof Document;
}
//#endregion
//#region src/capture/createXhrRequestBodyDetailEvent.ts
function er(e, t, n) {
	return $n(t) ? U(e, "request body", D(n.contentType, null)) : W(e, t, n);
}
//#endregion
//#region src/capture/startXhrRequestDetails.ts
function tr(e, t, n) {
	n.capture.captureRequestHeaders && Yt(e, t.headers, {
		...n,
		redactionPatterns: n.capture.redactionPatterns
	});
	let r = t.body;
	!n.capture.captureRequestBody || r === null || K(() => er(e, r, {
		contentType: E(t.headers),
		bodyCaptureLimit: n.capture.bodyCaptureLimit,
		redactionPatterns: n.capture.redactionPatterns
	}), n);
}
//#endregion
//#region src/capture/createXhrResponseBodyDetailEvent.ts
function nr(e, t, n) {
	return typeof t == "string" || t instanceof Blob || t instanceof ArrayBuffer ? Qt(e, t, n) : $n(t) ? U(e, "response body", D(n.contentType, null)) : T(e, "response body");
}
//#endregion
//#region src/capture/createXhrResponseBodyCaptureTask.ts
function rr(e, t, n) {
	try {
		return nr(e, t.response, {
			contentType: t.getResponseHeader("content-type"),
			bodyCaptureLimit: n.bodyCaptureLimit,
			redactionPatterns: n.redactionPatterns
		});
	} catch {
		return T(e, "response body");
	}
}
//#endregion
//#region src/capture/createXhrResponseHeadersDetailEvent.ts
function ir(e, t, n) {
	let r = G(t, n);
	return U(e, "response headers", Object.fromEntries(r.entries()));
}
//#endregion
//#region src/capture/startXhrResponseBodyCapture.ts
function ar(e, t, n) {
	K(() => rr(e, t, n), n);
}
//#endregion
//#region src/capture/createXhrResponseHeadersSnapshot.ts
function or(e) {
	let t = new Headers();
	for (let n of e.split(/\r\n|\n|\r/)) {
		let e = n.indexOf(":");
		e < 1 || t.append(n.slice(0, e), n.slice(e + 1).trim());
	}
	return t;
}
//#endregion
//#region src/capture/startXhrResponseHeadersCapture.ts
function sr(e, t, n) {
	K(() => ir(e, or(t.getAllResponseHeaders()), n.redactionPatterns), n);
}
//#endregion
//#region src/capture/startXhrResponseDetails.ts
function cr(e, t, n) {
	n.capture.captureResponseHeaders && sr(e, t, {
		...n,
		redactionPatterns: n.capture.redactionPatterns
	}), n.capture.captureResponseBody && ar(e, t, {
		...n,
		bodyCaptureLimit: n.capture.bodyCaptureLimit,
		redactionPatterns: n.capture.redactionPatterns
	});
}
//#endregion
//#region src/transport/allocateXhrSendAdmission.ts
function lr(e, t, n) {
	let r = on(t.requestedUrl, n.baseUrl);
	return {
		requestedUrl: mn(r, n.baseUrl, n.redactionPatterns),
		normalizedRequestedUrl: r,
		...pn(e, r, {
			filters: {
				includePatterns: n.includePatterns,
				excludePatterns: n.excludePatterns
			},
			admittedRequestCount: n.admittedRequestCount,
			autoStopLimit: n.autoStopLimit
		})
	};
}
//#endregion
//#region src/transport/createXhrSendMetadata.ts
function ur(e) {
	return {
		method: e.method,
		requestedUrl: e.requestedUrl,
		async: e.async
	};
}
//#endregion
//#region src/transport/createXhrSynchronousFailureObserver.ts
function dr(e, t, n) {
	return function(r) {
		if (e.claimTerminalOutcome()) try {
			e.removeTerminalListeners(), En(Tn({
				requestId: e.requestId,
				method: e.method,
				requestedUrl: e.requestedUrl,
				startMarker: e.startMarker,
				completionMarker: t(),
				failure: r
			}), n);
		} catch {} finally {
			e.settlePendingWork();
		}
	};
}
//#endregion
//#region src/transport/invokeObservedXhrSend.ts
function fr(e, t, n) {
	In(() => e(...t), n);
}
//#endregion
//#region src/outcomes/createTerminalOutcomeGate.ts
function pr() {
	let e = !1;
	function t() {
		return !e && (e = !0, !0);
	}
	return t;
}
//#endregion
//#region src/events/createTimedOutCompletionEvent.ts
function mr(e) {
	return {
		kind: "timed-out-completion",
		tokens: [
			{
				role: "identity",
				text: `Network #${e.requestId}`
			},
			{
				role: "direction",
				text: " <- "
			},
			{
				role: "outcome",
				text: "TIMED OUT"
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "method",
				text: e.method
			},
			{
				role: "plain",
				text: " "
			},
			{
				role: "url",
				text: e.url
			},
			{
				role: "plain",
				text: " ("
			},
			{
				role: "duration",
				text: Y(e.elapsedMilliseconds)
			},
			{
				role: "plain",
				text: ")"
			}
		]
	};
}
//#endregion
//#region src/redirects/getXhrRedirectUrl.ts
function hr(e, t) {
	if (t !== "" && t !== e) return t;
}
//#endregion
//#region src/transport/createXhrTerminalEvent.ts
function gr(e) {
	let t = {
		requestId: e.requestId,
		method: e.method,
		url: e.requestedUrl,
		elapsedMilliseconds: e.elapsedMilliseconds
	};
	if (e.eventType !== "load") {
		let n = {
			error: Sn,
			abort: Jn,
			timeout: mr
		}[e.eventType];
		return n(t);
	}
	let n = hr(e.normalizedRequestedUrl, e.responseUrl);
	return n === void 0 ? On({
		...t,
		status: e.status
	}) : kn({
		requestId: e.requestId,
		status: e.status,
		method: e.method,
		requestedUrl: e.requestedUrl,
		finalUrl: n,
		elapsedMilliseconds: e.elapsedMilliseconds
	});
}
//#endregion
//#region src/transport/createXhrTerminalObserver.ts
function Z(e, t, n) {
	return function() {
		if (n.claimTerminalOutcome()) try {
			if (!n.canEmitPendingOutput()) return;
			let r = n.getCompletionMarker();
			n.emit(gr({
				eventType: e,
				requestId: n.requestId,
				status: t.status,
				method: n.method,
				requestedUrl: n.requestedUrl,
				normalizedRequestedUrl: n.normalizedRequestedUrl,
				responseUrl: t.responseURL,
				elapsedMilliseconds: J(n.startMarker, r)
			})), e === "load" && n.startResponseDetails?.();
		} catch {} finally {
			n.settlePendingWork();
		}
	};
}
//#endregion
//#region src/transport/createXhrTerminalObservers.ts
function _r(e, t) {
	return {
		load: Z("load", e, t),
		error: Z("error", e, t),
		abort: Z("abort", e, t),
		timeout: Z("timeout", e, t)
	};
}
//#endregion
//#region src/transport/registerXhrTerminalListeners.ts
function vr(e, t) {
	return e.addEventListener("load", t.load), e.addEventListener("error", t.error), e.addEventListener("abort", t.abort), e.addEventListener("timeout", t.timeout), function() {
		e.removeEventListener("load", t.load), e.removeEventListener("error", t.error), e.removeEventListener("abort", t.abort), e.removeEventListener("timeout", t.timeout);
	};
}
//#endregion
//#region src/transport/startTracedXhrRequest.ts
function yr(e, t) {
	let n = pr(), r = _r(e, {
		...t,
		claimTerminalOutcome: n
	});
	t.beginPendingWork(), t.emit(xn(t.requestId, t.method, t.requestedUrl));
	let i = vr(e, r);
	return {
		requestId: t.requestId,
		method: t.method,
		requestedUrl: t.requestedUrl,
		startMarker: t.startMarker,
		claimTerminalOutcome: n,
		settlePendingWork: t.settlePendingWork,
		removeTerminalListeners: i
	};
}
//#endregion
//#region src/transport/invokeTracedXhrSend.ts
function br(e, t, n) {
	let r = yr(t.xhr, n);
	n.setActiveRequest(r), n.startRequestDetails?.(), fr(e, t.args, dr(r, n.getCompletionMarker, n.emit));
}
//#endregion
//#region src/transport/invokeXhrSendByAdmission.ts
function xr(e, t, n) {
	if (!n.admitted) {
		e(...t.args);
		return;
	}
	br(e, t, n);
}
//#endregion
//#region src/transport/invokeXhrSendRequest.ts
function Sr(e, t, n) {
	if (!n.isEnabled()) {
		e(...t.args);
		return;
	}
	let r = n.getOpenMetadata();
	if (r === void 0) {
		e(...t.args);
		return;
	}
	let i = ur(r), a = n.getConfig(), o = lr(n.getNextRequestId, i, {
		baseUrl: n.baseUrl,
		redactionPatterns: a.redactionPatterns,
		includePatterns: a.includePatterns,
		excludePatterns: a.excludePatterns,
		admittedRequestCount: n.getAdmittedRequestCount(),
		autoStopLimit: a.autoStopAfterRequests
	});
	if (fe(o, n.setAdmittedRequestCount, n.enterStopping), !o.admitted) {
		xr(e, t, { admitted: !1 });
		return;
	}
	let s = pe(a), c = n.getRequestHeaders();
	xr(e, t, {
		admitted: !0,
		requestId: o.requestId,
		method: i.method,
		requestedUrl: o.requestedUrl,
		normalizedRequestedUrl: o.normalizedRequestedUrl,
		startMarker: n.getMonotonicMarker(),
		getCompletionMarker: n.getMonotonicMarker,
		beginPendingWork: n.beginPendingWork,
		canEmitPendingOutput: n.canEmitPendingOutput,
		startRequestDetails: () => tr(o.requestId, {
			headers: c,
			body: t.args[0] ?? null
		}, {
			capture: s,
			beginPendingWork: n.beginPendingWork,
			canEmitPendingOutput: n.canEmitPendingOutput,
			emit: n.emit,
			settlePendingWork: n.settlePendingWork
		}),
		startResponseDetails: () => cr(o.requestId, t.xhr, {
			capture: s,
			beginPendingWork: n.beginPendingWork,
			canEmitPendingOutput: n.canEmitPendingOutput,
			emit: n.emit,
			settlePendingWork: n.settlePendingWork
		}),
		settlePendingWork: n.settlePendingWork,
		emit: n.emit,
		setActiveRequest: n.setActiveRequest
	});
}
//#endregion
//#region src/transport/invokeObservedXhrSetRequestHeader.ts
function Cr(e, t, n) {
	e(...t);
	try {
		n();
	} catch {}
}
//#endregion
//#region src/transport/invokeXhrSetRequestHeaderRequest.ts
function wr(e, t, n) {
	function r() {
		n(t[0], t[1]);
	}
	Cr(e, t, r);
}
//#endregion
//#region src/transport/createXhrWrapperHandlers.ts
function Tr(e, t) {
	function n(n, r, i) {
		let a = e.getInstanceStore(r), o = n.bind(r);
		function s(...e) {
			if (e.length === 2) {
				o(e[0], e[1]);
				return;
			}
			o(e[0], e[1], e[2], e[3], e[4]);
		}
		Qn(s, i, {
			getActiveRequest: a.getActiveRequest,
			clearActiveRequest: a.clearActiveRequest,
			setOpenMetadata: a.setOpenMetadata,
			clearRequestHeaders: a.clearRequestHeaders,
			getCompletionMarker: t.getMonotonicMarker,
			emit: t.emit
		});
	}
	function r(n, r, i) {
		let a = e.getInstanceStore(r);
		Sr(n.bind(r), {
			xhr: r,
			args: i
		}, {
			...t,
			...a
		});
	}
	function i(t, n, r) {
		let i = e.getInstanceStore(n);
		wr(t.bind(n), r, i.appendRequestHeader);
	}
	return {
		invokeOpen: n,
		invokeSend: r,
		invokeSetRequestHeader: i
	};
}
//#endregion
//#region src/transport/installFetchWrapper.ts
function Er(e, t) {
	let n = e.fetch;
	if (n === void 0) return !1;
	let r = n.bind(e);
	function i(e, n) {
		return arguments.length === 1 ? t(r, e) : t(r, e, n);
	}
	return e.fetch = i, !0;
}
//#endregion
//#region src/transport/installXhrWrappers.ts
function Dr(e, t) {
	if (e === void 0) return !1;
	let n = e.prototype.open, r = e.prototype.send, i = e.prototype.setRequestHeader;
	function a(...e) {
		t.invokeOpen(n, this, e);
	}
	function o(...e) {
		t.invokeSend(r, this, e);
	}
	function s(...e) {
		t.invokeSetRequestHeader(i, this, e);
	}
	return e.prototype.open = a, e.prototype.send = o, e.prototype.setRequestHeader = s, !0;
}
//#endregion
//#region src/output/concatenateEventTokens.ts
function Q(e) {
	return e.map((e) => e.text).join("");
}
//#endregion
//#region src/output/createCopyPasteEventArguments.ts
function Or(e) {
	return [Q(e.tokens)];
}
//#endregion
//#region src/output/createCopyPasteRedirectArguments.ts
function kr(e) {
	return [`${Q(e.completionTokens)}\n${Q(e.requestedTokens)}\n${Q(e.finalTokens)}`];
}
//#endregion
//#region ../../node_modules/.pnpm/safe-stable-stringify@2.5.0/node_modules/safe-stable-stringify/esm/wrapper.js
var Ar = /* @__PURE__ */ c((/* @__PURE__ */ o(((e, t) => {
	var { hasOwnProperty: n } = Object.prototype, r = _();
	r.configure = _, r.stringify = r, r.default = r, e.stringify = r, e.configure = _, t.exports = r;
	var i = /[\u0000-\u001f\u0022\u005c\ud800-\udfff]/;
	function a(e) {
		return e.length < 5e3 && !i.test(e) ? `"${e}"` : JSON.stringify(e);
	}
	function o(e, t) {
		if (e.length > 200 || t) return e.sort(t);
		for (let t = 1; t < e.length; t++) {
			let n = e[t], r = t;
			for (; r !== 0 && e[r - 1] > n;) e[r] = e[r - 1], r--;
			e[r] = n;
		}
		return e;
	}
	var s = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(Object.getPrototypeOf(/* @__PURE__ */ new Int8Array())), Symbol.toStringTag).get;
	function c(e) {
		return s.call(e) !== void 0 && e.length !== 0;
	}
	function l(e, t, n) {
		e.length < n && (n = e.length);
		let r = t === "," ? "" : " ", i = `"0":${r}${e[0]}`;
		for (let a = 1; a < n; a++) i += `${t}"${a}":${r}${e[a]}`;
		return i;
	}
	function u(e) {
		if (n.call(e, "circularValue")) {
			let t = e.circularValue;
			if (typeof t == "string") return `"${t}"`;
			if (t == null) return t;
			if (t === Error || t === TypeError) return { toString() {
				throw TypeError("Converting circular structure to JSON");
			} };
			throw TypeError("The \"circularValue\" argument must be of type string or the value null or undefined");
		}
		return "\"[Circular]\"";
	}
	function d(e) {
		let t;
		if (n.call(e, "deterministic") && (t = e.deterministic, typeof t != "boolean" && typeof t != "function")) throw TypeError("The \"deterministic\" argument must be of type boolean or comparator function");
		return t === void 0 || t;
	}
	function f(e, t) {
		let r;
		if (n.call(e, t) && (r = e[t], typeof r != "boolean")) throw TypeError(`The "${t}" argument must be of type boolean`);
		return r === void 0 || r;
	}
	function p(e, t) {
		let r;
		if (n.call(e, t)) {
			if (r = e[t], typeof r != "number") throw TypeError(`The "${t}" argument must be of type number`);
			if (!Number.isInteger(r)) throw TypeError(`The "${t}" argument must be an integer`);
			if (r < 1) throw RangeError(`The "${t}" argument must be >= 1`);
		}
		return r === void 0 ? Infinity : r;
	}
	function m(e) {
		return e === 1 ? "1 item" : `${e} items`;
	}
	function h(e) {
		let t = /* @__PURE__ */ new Set();
		for (let n of e) (typeof n == "string" || typeof n == "number") && t.add(String(n));
		return t;
	}
	function g(e) {
		if (n.call(e, "strict")) {
			let t = e.strict;
			if (typeof t != "boolean") throw TypeError("The \"strict\" argument must be of type boolean");
			if (t) return (e) => {
				let t = `Object can not safely be stringified. Received type ${typeof e}`;
				throw typeof e != "function" && (t += ` (${e.toString()})`), Error(t);
			};
		}
	}
	function _(e) {
		e = { ...e };
		let t = g(e);
		t && (e.bigint === void 0 && (e.bigint = !1), "circularValue" in e || (e.circularValue = Error));
		let n = u(e), r = f(e, "bigint"), i = d(e), s = typeof i == "function" ? i : void 0, _ = p(e, "maximumDepth"), v = p(e, "maximumBreadth");
		function y(e, l, u, d, f, p) {
			let h = l[e];
			switch (typeof h == "object" && h && typeof h.toJSON == "function" && (h = h.toJSON(e)), h = d.call(l, e, h), typeof h) {
				case "string": return a(h);
				case "object": {
					if (h === null) return "null";
					if (u.indexOf(h) !== -1) return n;
					let e = "", t = ",", r = p;
					if (Array.isArray(h)) {
						if (h.length === 0) return "[]";
						if (_ < u.length + 1) return "\"[Array]\"";
						u.push(h), f !== "" && (p += f, e += `\n${p}`, t = `,\n${p}`);
						let n = Math.min(h.length, v), i = 0;
						for (; i < n - 1; i++) {
							let n = y(String(i), h, u, d, f, p);
							e += n === void 0 ? "null" : n, e += t;
						}
						let a = y(String(i), h, u, d, f, p);
						if (e += a === void 0 ? "null" : a, h.length - 1 > v) {
							let n = h.length - v - 1;
							e += `${t}"... ${m(n)} not stringified"`;
						}
						return f !== "" && (e += `\n${r}`), u.pop(), `[${e}]`;
					}
					let l = Object.keys(h), g = l.length;
					if (g === 0) return "{}";
					if (_ < u.length + 1) return "\"[Object]\"";
					let b = "", x = "";
					f !== "" && (p += f, t = `,\n${p}`, b = " ");
					let S = Math.min(g, v);
					i && !c(h) && (l = o(l, s)), u.push(h);
					for (let n = 0; n < S; n++) {
						let r = l[n], i = y(r, h, u, d, f, p);
						i !== void 0 && (e += `${x}${a(r)}:${b}${i}`, x = t);
					}
					if (g > v) {
						let n = g - v;
						e += `${x}"...":${b}"${m(n)} not stringified"`, x = t;
					}
					return f !== "" && x.length > 1 && (e = `\n${p}${e}\n${r}`), u.pop(), `{${e}}`;
				}
				case "number": return isFinite(h) ? String(h) : t ? t(h) : "null";
				case "boolean": return h === !0 ? "true" : "false";
				case "undefined": return;
				case "bigint": if (r) return String(h);
				default: return t ? t(h) : void 0;
			}
		}
		function b(e, i, o, s, c, l) {
			switch (typeof i == "object" && i && typeof i.toJSON == "function" && (i = i.toJSON(e)), typeof i) {
				case "string": return a(i);
				case "object": {
					if (i === null) return "null";
					if (o.indexOf(i) !== -1) return n;
					let e = l, t = "", r = ",";
					if (Array.isArray(i)) {
						if (i.length === 0) return "[]";
						if (_ < o.length + 1) return "\"[Array]\"";
						o.push(i), c !== "" && (l += c, t += `\n${l}`, r = `,\n${l}`);
						let n = Math.min(i.length, v), a = 0;
						for (; a < n - 1; a++) {
							let e = b(String(a), i[a], o, s, c, l);
							t += e === void 0 ? "null" : e, t += r;
						}
						let u = b(String(a), i[a], o, s, c, l);
						if (t += u === void 0 ? "null" : u, i.length - 1 > v) {
							let e = i.length - v - 1;
							t += `${r}"... ${m(e)} not stringified"`;
						}
						return c !== "" && (t += `\n${e}`), o.pop(), `[${t}]`;
					}
					o.push(i);
					let u = "";
					c !== "" && (l += c, r = `,\n${l}`, u = " ");
					let d = "";
					for (let e of s) {
						let n = b(e, i[e], o, s, c, l);
						n !== void 0 && (t += `${d}${a(e)}:${u}${n}`, d = r);
					}
					return c !== "" && d.length > 1 && (t = `\n${l}${t}\n${e}`), o.pop(), `{${t}}`;
				}
				case "number": return isFinite(i) ? String(i) : t ? t(i) : "null";
				case "boolean": return i === !0 ? "true" : "false";
				case "undefined": return;
				case "bigint": if (r) return String(i);
				default: return t ? t(i) : void 0;
			}
		}
		function x(e, u, d, f, p) {
			switch (typeof u) {
				case "string": return a(u);
				case "object": {
					if (u === null) return "null";
					if (typeof u.toJSON == "function") {
						if (u = u.toJSON(e), typeof u != "object") return x(e, u, d, f, p);
						if (u === null) return "null";
					}
					if (d.indexOf(u) !== -1) return n;
					let t = p;
					if (Array.isArray(u)) {
						if (u.length === 0) return "[]";
						if (_ < d.length + 1) return "\"[Array]\"";
						d.push(u), p += f;
						let e = `\n${p}`, n = `,\n${p}`, r = Math.min(u.length, v), i = 0;
						for (; i < r - 1; i++) {
							let t = x(String(i), u[i], d, f, p);
							e += t === void 0 ? "null" : t, e += n;
						}
						let a = x(String(i), u[i], d, f, p);
						if (e += a === void 0 ? "null" : a, u.length - 1 > v) {
							let t = u.length - v - 1;
							e += `${n}"... ${m(t)} not stringified"`;
						}
						return e += `\n${t}`, d.pop(), `[${e}]`;
					}
					let r = Object.keys(u), h = r.length;
					if (h === 0) return "{}";
					if (_ < d.length + 1) return "\"[Object]\"";
					p += f;
					let g = `,\n${p}`, y = "", b = "", S = Math.min(h, v);
					c(u) && (y += l(u, g, v), r = r.slice(u.length), S -= u.length, b = g), i && (r = o(r, s)), d.push(u);
					for (let e = 0; e < S; e++) {
						let t = r[e], n = x(t, u[t], d, f, p);
						n !== void 0 && (y += `${b}${a(t)}: ${n}`, b = g);
					}
					if (h > v) {
						let e = h - v;
						y += `${b}"...": "${m(e)} not stringified"`, b = g;
					}
					return b !== "" && (y = `\n${p}${y}\n${t}`), d.pop(), `{${y}}`;
				}
				case "number": return isFinite(u) ? String(u) : t ? t(u) : "null";
				case "boolean": return u === !0 ? "true" : "false";
				case "undefined": return;
				case "bigint": if (r) return String(u);
				default: return t ? t(u) : void 0;
			}
		}
		function S(e, u, d) {
			switch (typeof u) {
				case "string": return a(u);
				case "object": {
					if (u === null) return "null";
					if (typeof u.toJSON == "function") {
						if (u = u.toJSON(e), typeof u != "object") return S(e, u, d);
						if (u === null) return "null";
					}
					if (d.indexOf(u) !== -1) return n;
					let t = "", r = u.length !== void 0;
					if (r && Array.isArray(u)) {
						if (u.length === 0) return "[]";
						if (_ < d.length + 1) return "\"[Array]\"";
						d.push(u);
						let e = Math.min(u.length, v), n = 0;
						for (; n < e - 1; n++) {
							let e = S(String(n), u[n], d);
							t += e === void 0 ? "null" : e, t += ",";
						}
						let r = S(String(n), u[n], d);
						if (t += r === void 0 ? "null" : r, u.length - 1 > v) {
							let e = u.length - v - 1;
							t += `,"... ${m(e)} not stringified"`;
						}
						return d.pop(), `[${t}]`;
					}
					let f = Object.keys(u), p = f.length;
					if (p === 0) return "{}";
					if (_ < d.length + 1) return "\"[Object]\"";
					let h = "", g = Math.min(p, v);
					r && c(u) && (t += l(u, ",", v), f = f.slice(u.length), g -= u.length, h = ","), i && (f = o(f, s)), d.push(u);
					for (let e = 0; e < g; e++) {
						let n = f[e], r = S(n, u[n], d);
						r !== void 0 && (t += `${h}${a(n)}:${r}`, h = ",");
					}
					if (p > v) {
						let e = p - v;
						t += `${h}"...":"${m(e)} not stringified"`;
					}
					return d.pop(), `{${t}}`;
				}
				case "number": return isFinite(u) ? String(u) : t ? t(u) : "null";
				case "boolean": return u === !0 ? "true" : "false";
				case "undefined": return;
				case "bigint": if (r) return String(u);
				default: return t ? t(u) : void 0;
			}
		}
		function ee(e, t, n) {
			if (arguments.length > 1) {
				let r = "";
				if (typeof n == "number" ? r = " ".repeat(Math.min(n, 10)) : typeof n == "string" && (r = n.slice(0, 10)), t != null) {
					if (typeof t == "function") return y("", { "": e }, [], t, r, "");
					if (Array.isArray(t)) return b("", e, [], h(t), r, "");
				}
				if (r.length !== 0) return x("", e, [], r, "");
			}
			return S("", e, []);
		}
		return ee;
	}
})))());
Ar.configure;
var jr = Ar.default;
//#endregion
//#region src/output/formatDetailValueForOutputMode.ts
function Mr(e, t) {
	if (typeof e != "object" || !e) return e;
	if (t === "devtools") return Ut(e);
	let n = jr.configure({
		circularValue: "[Circular]",
		maximumDepth: 10,
		maximumBreadth: 50
	});
	function r(e, t) {
		return typeof t == "bigint" ? `${t}n` : t instanceof Error ? {
			name: t.name,
			message: t.message
		} : t instanceof Map ? Array.from(t.entries()) : t instanceof Set ? Array.from(t.values()) : t;
	}
	try {
		return n(e, r) ?? "\"[Unserializable]\"";
	} catch {
		return "\"[Unserializable]\"";
	}
}
//#endregion
//#region src/output/createCopyPasteStructuredDetailArguments.ts
function Nr(e) {
	let t = Q(e.tokens), n = Mr(e.value, "copy-paste");
	return [`${t}${String(n)}`];
}
//#endregion
//#region src/theme/buildNetworkThemeStyle.ts
function Pr(e) {
	let t = [];
	return e.text !== void 0 && t.push(`color: ${e.text}`), e.background !== void 0 && t.push(`background: ${e.background}`), e.bold === !0 && t.push("font-weight: bold"), e.italic === !0 && t.push("font-style: italic"), t.join("; ");
}
//#endregion
//#region src/outcomes/isHttpErrorStatus.ts
function Fr(e) {
	return e >= 400 && e <= 599;
}
//#endregion
//#region src/theme/resolveEventTokenThemeCategory.ts
function Ir(e) {
	return e.role === "status" ? Fr(Number(e.text)) ? "error" : void 0 : {
		identity: "identity",
		method: "method",
		label: "detailLabel",
		outcome: "error",
		redirect: "redirect",
		unavailable: "error",
		"runtime-control": "runtimeControl"
	}[e.role];
}
//#endregion
//#region src/output/renderEventTokensForDevTools.ts
function $(e, t, n) {
	let r = "", i = [];
	for (let a of e) {
		let e = Ir(a), o = e === void 0 ? {} : t[e][n === "dark" ? "darkMode" : "lightMode"];
		r += `%c${a.text}`, i.push(Pr(o));
	}
	return {
		format: r,
		styles: i
	};
}
//#endregion
//#region src/output/createDevToolsEventArguments.ts
function Lr(e, t, n) {
	let r = $(e.tokens, t, n);
	return [r.format, ...r.styles];
}
//#endregion
//#region src/output/createDevToolsRedirectArguments.ts
function Rr(e, t, n) {
	let r = $(e.completionTokens, t, n), i = $(e.requestedTokens, t, n), a = $(e.finalTokens, t, n);
	return [
		`${r.format}\n${i.format}\n${a.format}`,
		...r.styles,
		...i.styles,
		...a.styles
	];
}
//#endregion
//#region src/output/createDevToolsStructuredDetailArguments.ts
function zr(e, t, n) {
	let r = $(e.tokens, t, n);
	return [
		r.format,
		...r.styles,
		Mr(e.value, "devtools")
	];
}
//#endregion
//#region src/output/createNetworkEventArguments.ts
function Br(e, t) {
	return "completionTokens" in e ? t.outputMode === "devtools" ? Rr(e, t.theme, t.colorMode) : kr(e) : "value" in e ? t.outputMode === "devtools" ? zr(e, t.theme, t.colorMode) : Nr(e) : t.outputMode === "devtools" ? Lr(e, t.theme, t.colorMode) : Or(e);
}
//#endregion
//#region src/runtime/createNetworkEventEmitter.ts
function Vr(e, t) {
	return (n) => {
		t(...Br(n, e()));
	};
}
//#endregion
//#region src/state/canEmitPendingOutput.ts
function Hr(e) {
	return e !== "stopped";
}
//#endregion
//#region src/runtime/createNetworkTransportRuntime.ts
function Ur(e) {
	return {
		baseUrl: e.baseUrl,
		isEnabled: e.stateStore.isEnabled,
		canEmitPendingOutput: () => Hr(e.stateStore.getState()),
		getConfig: e.configStore.getConfig,
		getNextRequestId: e.requestIds.getNextRequestId,
		getAdmittedRequestCount: e.admittedRequests.getAdmittedRequestCount,
		setAdmittedRequestCount: e.admittedRequests.setAdmittedRequestCount,
		enterStopping: e.commands.enterAutomaticStopping,
		getMonotonicMarker: e.getMonotonicMarker,
		beginPendingWork: e.stateStore.beginPendingWork,
		settlePendingWork: e.commands.settlePendingWork,
		emit: e.emit
	};
}
//#endregion
//#region src/runtime/createNetworkTracerRuntime.ts
function Wr(e) {
	let t = se(e.storage, e.initializerDefaults), n = ue(!1), r = le(), i = ce(), a = de(), o = Vr(e.getOutputSettings, e.log), s = ne({
		stateStore: n,
		drainStore: a,
		requestIds: r,
		admittedRequests: i,
		getWaitForPendingRequests: () => t.getConfig().waitForPendingRequestsOnStop,
		emit: o
	}), c = Ur({
		stateStore: n,
		configStore: t,
		requestIds: r,
		admittedRequests: i,
		commands: s,
		baseUrl: e.baseUrl,
		getMonotonicMarker: e.getMonotonicMarker,
		emit: o
	}), d = Er(e.target, Hn(c)), f = Dr(e.target.XMLHttpRequest, Tr(Gn(), c)), p = d || f;
	p && t.getConfig().enabledOnLoad && n.enterRunning();
	function m() {
		p && s.start();
	}
	function h() {
		p && s.stop();
	}
	function g() {
		p && s.forceStop();
	}
	return l({
		start: m,
		stop: h,
		forceStop: g
	}, n, u(t));
}
//#endregion
//#region src/runtime/detectNetworkColorMode.ts
function Gr(e) {
	if (e.matchMedia === void 0) return "light";
	try {
		return e.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
	} catch {
		return "light";
	}
}
//#endregion
//#region src/runtime/getOrCreateNetworkAutoTracerApi.ts
function Kr(e) {
	function t(e) {
		return typeof e != "object" || !e ? !1 : "getOutputMode" in e && typeof e.getOutputMode == "function" && "setOutputMode" in e && typeof e.setOutputMode == "function";
	}
	if (t(e.autoTracer)) return e.autoTracer;
	let n = e.__autoTracerInternal ?? {
		outputMode: "devtools",
		subscribers: []
	};
	e.__autoTracerInternal = n;
	function r() {
		return n.outputMode;
	}
	function i(e) {
		n.outputMode = e, n.subscribers.forEach((t) => t(e));
	}
	let a = {
		getOutputMode: r,
		setOutputMode: i
	};
	return e.autoTracer = a, a;
}
//#endregion
//#region src/runtime/getConflictingNetworkTracerDefaultKeys.ts
function qr(e, t) {
	let n = C(e, {}), r = C(t, {});
	return [
		["enabledOnLoad", n.enabledOnLoad === r.enabledOnLoad],
		["captureRequestHeaders", n.captureRequestHeaders === r.captureRequestHeaders],
		["captureRequestBody", n.captureRequestBody === r.captureRequestBody],
		["captureResponseHeaders", n.captureResponseHeaders === r.captureResponseHeaders],
		["captureResponseBody", n.captureResponseBody === r.captureResponseBody],
		["bodyCaptureLimit", n.bodyCaptureLimit === r.bodyCaptureLimit],
		["redactionPatterns", JSON.stringify(n.redactionPatterns) === JSON.stringify(r.redactionPatterns)],
		["includePatterns", JSON.stringify(n.includePatterns) === JSON.stringify(r.includePatterns)],
		["excludePatterns", JSON.stringify(n.excludePatterns) === JSON.stringify(r.excludePatterns)],
		["waitForPendingRequestsOnStop", n.waitForPendingRequestsOnStop === r.waitForPendingRequestsOnStop],
		["autoStopAfterRequests", n.autoStopAfterRequests === r.autoStopAfterRequests]
	].filter((e) => !e[1]).map((e) => e[0]);
}
//#endregion
//#region src/runtime/installNetworkTracerRuntime.ts
function Jr(e) {
	let t = e.realm.__autoTracerNetworkRuntime;
	if (t !== void 0) {
		let n = qr(t.initializerDefaults, e.initializerDefaults);
		return n.length > 0 && e.log(`NetworkTracer ignored conflicting initializer defaults: ${n.join(", ")}.`), t.api;
	}
	let n = e.realm.autoTracer;
	if (n === void 0) throw Error("NetworkTracer requires shared AutoTracer controls.");
	let r = e.createRuntime(e.initializerDefaults);
	return n.networkTracer = r, e.realm.__autoTracerNetworkRuntime = {
		api: r,
		initializerDefaults: C(e.initializerDefaults, {})
	}, r;
}
//#endregion
//#region src/theme/defaultNetworkTheme.ts
var Yr = {
	identity: {
		lightMode: {
			text: "#0000ff",
			bold: !0
		},
		darkMode: {
			text: "#569cd6",
			bold: !0
		}
	},
	method: {
		lightMode: { text: "#795e26" },
		darkMode: { text: "#dcdcaa" }
	},
	detailLabel: {
		lightMode: { text: "#267f99" },
		darkMode: { text: "#4ec9b0" }
	},
	error: {
		lightMode: {
			text: "#cd3131",
			bold: !0
		},
		darkMode: {
			text: "#f44747",
			bold: !0
		}
	},
	redirect: {
		lightMode: {
			text: "#9d5d00",
			bold: !0
		},
		darkMode: {
			text: "#d7ba7d",
			bold: !0
		}
	},
	runtimeControl: {
		lightMode: { text: "#008000" },
		darkMode: { text: "#6a9955" }
	}
};
//#endregion
//#region src/networkTracer.ts
function Xr(e = {}) {
	let t = Kr(globalThis);
	return Jr({
		realm: globalThis,
		initializerDefaults: e,
		createRuntime: (e) => Wr({
			target: globalThis,
			storage: globalThis.localStorage,
			initializerDefaults: e,
			baseUrl: globalThis.location.href,
			getMonotonicMarker: () => globalThis.performance.now(),
			getOutputSettings: () => ({
				outputMode: t.getOutputMode(),
				theme: Yr,
				colorMode: Gr(globalThis)
			}),
			log: (...e) => globalThis.console.log(...e)
		}),
		log: (e) => globalThis.console.log(e)
	});
}
//#endregion
export { Xr as networkTracer };
